export const zh = {
    addDatabase: {
        addDatabase: "æ·»å æ°æ®åº",
        addFromFile: "ä»æä»¶æ·»å ",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "All packages",
        onePackage: "One package",
        priceType: "ä»·æ ¼ç±»å",
        setPriceVatVisibility: "Set VAT visibility",
        setVisibilityAndOrder: "Set visibility and order of price types",
        withAndWithoutVat: "Both with and without VAT",
        withVat: "Only with VAT",
        withoutVat: "Only without VAT"
    },
    barvis: {
        base: "Base name",
        bigCanSize: "Big cans",
        coating: "Coating",
        identifier: "Idenfitier",
        laboratory: "Laboratory",
        orderOverview: "Order overview",
        rank: "Rank",
        smallCanSize: "Small cans"
    },
    basicSetup: {
        alreadyLoggedIn: "You are already logged in as %{login}.",
        askSupplier: " Ask your software supplier to assign more licenses to you.",
        asterisk: "Items marked with an asterisk must be filled in.",
        identificationKeys: "Identification keys",
        importCustomData: "If applicable, import your custom data from the previous dispensing software.",
        learnIdentification: "Learn the identification keys from your software supplier.",
        login: "The following steps of the initial setup require admin rights.",
        noDatabase: "No database has been added yet, at least one must be inserted.",
        offlineLicensing: "Offline licensing",
        productSelection: "Product selection",
        registrationForm: "Registration form",
        seeQuestionMark: "See the small question marks to learn more about the setting.",
        selectDefaultPrinter: "Select the default printer and set additional configuration.  ",
        selectDefaultTemplate:
            "Select the default templates from the already existing ones, create a new template or load your own.",
        selectDispenser: "Select the dispenser type you are using.",
        selectLanguage: "Select your language.",
        selectProducts: "Select one of the available products which you want to activate.",
        selectSpectroType: "Select the spectro type you are using.",
        setAdditionalPrinterOptions: "Set additional printer options.",
        setAutomaticUpdates: "Set the automatic updates options.",
        setCustomItems: "Set the custom items and data visibility. Scroll down to see more options.",
        setEnvironment: "Set the overall environment of the software. Scroll down to see more options.",
        setFormulaRepresentation: "Set the formula representation. Scroll down to see more options.",
        summary:
            "You can change these settings at any time and find even more configuration options. Enjoy using %{name}!",
        summarySuccess: "You are all set up!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "è®¾ç½®ç½çº§",
        criticalLevelCanister: "Critical Canister Levels",
        fillToMax: "å¡«å æå¤§éåº¦",
        maxDispenseLevel: "Dispense max",
        otherCanisters: "å¶ä»ç½è£",
        warningLevelCanister: "Warning Canister Levels"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "Available Service Actions",
        canisterInformation: "Canister Information",
        canisterPreview: "ç½è£é¢è§",
        currentLevel: "å½åéåº¦",
        errors: "éè¯¯",
        fillState: "å¡«å ç¶æ",
        fillToMax: "å¡«å æå¤§éåº¦",
        fillingAmount: "Filling amount",
        finalLevel: "Final level",
        minimumAmount: "æä½æ°é",
        minimumLevel: "æå°éåº¦",
        moveTableToRefill: "ç§»å¨æ¡é¢éæ°å¡«å ",
        refillNoAmount: "No amount entered",
        refillOverLimit: "Entered amount exceeds the maximal canister capacity",
        refillSummary: "%{amount} %{unit} of the colorant %{colorant} will be added to the canister %{canisterId}.",
        systemWarningAmount: "ç³»ç»è­¦åæ°é",
        warningAmount: "è­¦åæ°é"
    },
    changeDatabase: {
        changeDatabase: "æ´æ¹æ°æ®åº",
        databaseWarning: "Database %{databaseName} cannot be used due to"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "æ¸æ´ææç®¡é",
        cleanChannels: "æ¸æ´ç®¡é",
        cleaningTime: "æ¸æ´æ¶é´",
        selectChannels: "éæ©ç®¡é",
        startCleaning: "å¼å§æ¸æ´"
    },
    clientServerSettings: {
        activeServer: "æ¿æ´»æå¡å¨",
        addNewServer: "æ·»å æ°æå¡å¨",
        availableServers: "å¶ä»å¯ç¨æå¡å¨",
        clientIdentifier: "Client identifier",
        clientServerSettings: "å®¢æ·/æå¡å¨è®¾ç½®",
        disabledStatus: "ç¦ç¨",
        editServer: "ç¼è¾æå¡å¨",
        fillRequiredFields: "Required fields must be filled in",
        noOtherServers: "æ å¯ç¨å¶ä»æå¡å¨",
        offlineStatus: "ç¦»çº¿",
        onlineStatus: "å¨çº¿",
        port: "ç«¯å£",
        serverName: "æå¡å¨åç§°",
        serverNameMissing: "Server name must be filled in",
        stabileConnection: "To ensure stabile connection, use static IP address.",
        wrongFormatIp: "Wrong format of IP address"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Color tone",
        fandeckPosition: "Fandeck position",
        moreInfoIcons: "More info icons",
        notExistingFormula: "Non-existent formula",
        orderBy: "Order by",
        selectYourGrid: "Select your grid",
        showInPanel: "Show in panel",
        warningIcon: "Non-existent formula warning icon"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "Number of colorants:",
        preview: "Preview",
        prices: "Prices"
    },
    currencySettings: {
        addNewCurrency: "æ·»å æ°è´§å¸",
        codePlaceholder: "ä»£ç ",
        currencySettings: "è´§å¸è®¾ç½®",
        namePlaceholder: "åç§°",
        ratePlaceholder: "æ±ç",
        setDecimalPlaces: "è®¾ç½®å°æ°ç¹åä½æ°",
        setMainCurrency: "è®¾ç½®ä¸»è¦è´§å¸",
        setRounding: "è®¾ç½®åèäºå¥",
        symbolPlaceholder: "ç¬¦å·"
    },
    customFandecks: {
        customFandecks: "èªå®ä¹é¢è²èå´",
        deleteButtonWarning: "All formulas in fandeck will be removed too.",
        deleteCustomFandeck:
            "Do you really want to delete this custom fandeck? All formulas in this fandeck will be deleted too.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "Fandeck name"
    },
    customRedlike: {
        addColorantFromBrand: "Add colorant from %{brandName} brand",
        addNewCustomer: "æ·»å æ°å®¢æ·",
        addNewNote: "æ·»å æ°å¤æ³¨",
        addedDate: "æ·»å æ¥æ",
        addedQuantity: "æ·»å æ°é",
        availableMachine: "å¯ç¨æºå¨",
        brand: "åç",
        brandPlease: "éæ©åç",
        cancelCustomer: "Cancel customer",
        colorPlease: "éæ©åç",
        confirmCustomerData: "ç¡®è®¤ç¨æ·ä¿¡æ¯",
        confirmNoteData: "ç¡®è®¤å¤ä»½ä¿¡æ¯",
        confirmSelectedUser: "Do you want to use customer %{customerName} for this order.",
        confirmed: "ç¡®è®¤",
        controlData: "ææ°æ£æ¥æ°æ®",
        customerCellNumber: "å®¢æ·ææº",
        customerFilter: "è¿æ»¤å®¢æ·",
        customerName: "å®¢æ·å",
        customerPhone: "å®¢æ·çµè¯",
        customerPlease: "éæ©å®¢æ·",
        dateFilter: "è¿æ»¤æ¥æ",
        enterPin: "è¾å¥å¯ç ",
        enterTheNumberOfPackages: "è¾å¥åè£æ°é",
        existingCustomer: "ç¨æ·å·²å­å¨",
        fandeckPlease: "éæ©é¢è²èå´",
        fillCanisterHistory: "ç½è£åå²",
        findCustomer: "To assign loyalty card to this order please scan barcode or search email address",
        findCustomerByEmail: "Filter customer by email or barcode",
        finishPreviousStep: "å®æä¸ä¸æ­¥æä½",
        formulaUnit: "éæ¹åä½",
        getBackToList: "è¿åå°å®¢æ·åå",
        historyOfOrders: "åå²æä½",
        insertNote: "åå¾åè¡¨è¯è®º",
        loadHistoryOrder: "æ¨è¦ä¿å­æéæä½å",
        loyaltyCards: "Loyalty cards",
        machineIsAvailable: "æºå¨å¯ç¨",
        machineIsUnavailable: "æºå¨ä¸å¯ç¨",
        newLoyaltyCard: "New loyalty card",
        noAvailableMachine: "æºå¨ä¸å¯ç¨",
        noCustomerSelected: "No customer is selected. Do you want continue?",
        notePlease: "æ·»å å¤æ³¨",
        openHistory: "æå¼åå²",
        orAdd: "æèæ·»å å®¢æ·",
        orSelect: "æèéæ©å®¢æ·",
        orderModification: "The original order will be modified. Do you want to continue?",
        orderOverview: "è®¢åæ»è§",
        orderToMachine: "åéè®¢å",
        ordersHistory: "History of orders",
        packagePlease: "éæ©åè£",
        pleaseSelectBrand: "éæ©åç",
        previewImage: "é¢è§å¾ç",
        previewPackage: "åè£å®ä¾",
        productPlease: "éæ©äº§å",
        resetFilters: "éç½®æ»¤é",
        searchForHistoricalOrders: "éæ©åå²è®¢å",
        selectBrand: "éæ©åç",
        selectColor: "åå¾éæ©é¢è²",
        selectCustomer: "åå¾éæ©å®¢æ·",
        selectExistingCustomer: "éæ©å·²å­å¨å®¢æ·",
        selectFandeck: "åå¾éæ©é¢è²èå´",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "åå¾éæ©åè£",
        selectProduct: "åå¾éæ©äº§å",
        shotsCoefficient: "åºæç",
        showDetail: "Show detail",
        showHideEshopName: "Show/Hide the eshop name of the color in a separate column",
        showKeyboard: "æ¾ç¤ºé®ç",
        skipCustomerButton: "è·³è¿âéæ©å®¢æ·â",
        skipCustomerText: "å¦æä¸éè¦æ·»å å®¢æ·è¯·è·³è¿",
        skipNote: "è·³è¿å¤æ³¨æ¥çæ¦è¿°",
        spectroBrand: "Searching in brand %{brandName}",
        statusAccepted: "æ¥å",
        statusCanceled: "å·²ç»åæ¶",
        statusCreated: "å·²ç»åå»º",
        statusDone: "å®æ",
        statusPartlyDone: "é¨åå·²å®æ",
        statusPreparing: "é¢è§",
        summaryChosenBase: "åºç¡æµ",
        summaryChosenBrand: "åç",
        summaryChosenCanSize: "ç½è£è§æ ¼",
        summaryChosenColor: "é¢è²",
        summaryChosenColorCard: "è²å¡",
        summaryChosenProduct: "äº§å",
        summaryChosenQuantity: "æ°é",
        summaryColorPreview: "é¢è²é¢è§",
        summaryCustomNote: "å®¢æ·ç¼å·",
        summaryCustomerNumber: "å®¢æ·",
        summaryFormula: "éæ¹",
        summaryFormulaNote: "éæ¹å¤æ³¨",
        summaryNote: "å¤æ³¨",
        sureAboutSend: "æ¨ç¡®å®è¦åéè®¢ååï¼",
        useCustomerInOrder: "Do you want to use %{customerName} in the following order?",
        uuid: "æå¡å¨æ°æ®åºåè®¸å¯è¯æ°æ®",
        viewSummary: "æ¥çæ»è§",
        volume: "åå®¹"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "è®¢åç¡®è®¤ç ",
        pinScreenSaverConfirmation: "ä»£ç ç¡®è®¤å±ä¿",
        pinSettingsConfirmation: "ä»£ç ç¡®è®¤è®¾ç½®",
        printAuto: "Allow print automatically",
        printerSettings: "Printer settings",
        selectColorWithFandeck: "éç¨é¢è²åèå´éé¡¹",
        setKeyboard: "é®çè®¾ç½®",
        setKioskMode: "è®¾ç½®èªå©æå¡ç»ç«¯æ¨¡å¼",
        setLanguage: "è®¾ç½®è¯­è¨",
        setModule: "è®¾ç½®æ¨¡å",
        setQuickSelect: "è®¾ç½®å¿«ééæ©",
        setScreensaverTimeout: "è®¾ç½®å±ä¿è¶æ¶",
        setUnit: "è®¾ç½®åä½"
    },
    customRedlikeMachine: {
        action: "æ§è¡",
        additionalPrint: "é¢å¤æ ç­¾",
        brand: "æ è®°",
        brandAccess: "ç¨æ· '%{userName}' æ æ³è®¿é®åç '%{brandName}'çæ°æ®",
        can: "ææ¾",
        canistersLevel: "ç½è£çº§å«é¢è§",
        closeDetailInformation: "å³é­ç»è",
        colorantsAmount: "è²æµçº§å«",
        confirmRefill: "ç¡®è®¤å¡«å ",
        deleteOrder: "å é¤ä½ä¸",
        dialogNoMachine: "æºå¨æªè¿æ¥",
        dialogNoRcc: "RCCæªè¿æ¥",
        dispense: "åé",
        dispenserInErrorState: "åéå¨å¤äºéè¯¯ç¶æ",
        dispensingIsOk: "åéå¨OK",
        emergencyButtonPressed: "æä¸ç´§æ¥æé®",
        errorCode: "ä»£ç éè¯¯",
        errorEvents: "åéå¨éè¯¯",
        errorReset: "éç½®éè¯¯",
        explanation: "è¯´æ",
        imageNotAvailable: "å¾åä¸å¯ç¨",
        incorrectCanister: "æ«æå°éè¯¯ç½è£",
        incorrectColorant: "éè¯¯ï¼æ«æå°éè¯¯è²æµãæ«ææ­£ç¡®ç½è£",
        lastEvents: "æè¿çæä½",
        machineActions: "æåºè°è²æº",
        machineConfiguration: "Dispenser configuration",
        machineError: "è®¾å¤éè¯¯",
        machineIsBusy: "è®¾å¤æ­£å¿",
        machineNotAvailable: "è®¾å¤ä¸å¯ç¨",
        machineTinting: "ç­å¾ï¼è®¾å¤å¨è°è²",
        manualScan: "æå¨æ«æ",
        notEnoughSpace: "éè¯¯ï¼æ²¡æè¶³å¤ç©ºé´",
        numberOfCanistersUnderCriticalLevel: "ä½äºä¸´çæ°´å¹³çç½æ°ä¸º %{0}",
        numberOfCanistersUnderWarningLevel: "ä½äºè­¦åçº§å«çç½æ°ä¸º %{0}",
        offlinePressed: "æä¸éé¢æé®",
        orderSettings: "è®¢åè®¾ç½®",
        otherOrderInformation: "è®¢åæç»",
        packageCount: "æ°é",
        packageWithSeparator: "åè£ è§æ ¼",
        received: "æ¥æ¶",
        receivedOrders: "æ¥æ¶æä»¤",
        receivedTime: "æ¥æ¶æ¶é´",
        recirculation: "åå¾ªç¯",
        refillInformation: "è²æµï¼%{0}ï¼å¡«åçº§å«ï¼ %{1}ï¼å®¹å¨ï¼%{2}",
        resetErrors: "éç½®éè¯¯",
        scanCanister: "æ«æå®¹å¨",
        scanColorantPackage: "æ«ææéè²æµåè£",
        selectedOrder: "éå®çä»»å¡",
        shelfMovingDown: "æçä¸ç§»",
        shelfMovingUp: "æçä¸ç§»",
        solution: "è§£å³æ¹æ¡",
        startDispensing: "å¼å§è°è²",
        stirring: "ææ",
        touchToStartFilling: "ææ­¤å¤å¼å§æ·»å ",
        unknownBrand: "æªç¥åç"
    },
    customRedlikeSettings: {
        addPos: "POSä¿¡æ¯",
        addServer: "æ·»å æå¡å¨",
        adminOperations: "Admin operations",
        adminSettings: "ç®¡çåè®¾ç½®",
        another: "å¶ä»",
        aslOrService: "ASLææå¡å¨",
        availableMachines: "å¯ç¨æºå¨",
        barcode: "æ¡å½¢ç ",
        basicOperations: "åºæ¬æä½",
        canisterBarcodes: "ç½è£æ¡å½¢ç ",
        canisterLevels: "ç½è£çº§å«",
        closeConnection: "Close connection",
        closeRedlike: "å³é­%{name}",
        databaseList: "æ°æ®åº",
        disabledStatus: "ç¦ç¨",
        dispenseLogicType: "Dispense logic type",
        dropServers: "å é¤æå¡å¨",
        editServer: "ç¼è¾æå¡å¨",
        lastEvent: "æè¿æä½",
        logOut: "éåº",
        machineConfiguration: "Configuration",
        maxDispenseAmount: "Max dispense amount",
        offlineStatus: "ç¦»çº¿",
        onlineStatus: "å¨çº¿",
        openFrondesk: "æå¼åå°",
        print: "Print settings",
        rebootPC: "éå¯çµè",
        restartRedlike: "éå¯%{name}",
        restoreConnection: "Restore connection",
        scanCanisterBarcode: "æ«æç½è£æ¡å½¢ç ",
        scanOrDeleteCanisterBarcode: "Scan or delete barcode",
        setCanisterBarcode: "è®¾ç½®ç½è£æ¡å½¢ç ",
        swVersion: "è½¯ä»¶çæ¬",
        systemFunctions: "ç³»ç»åè½",
        userSettings: "ç¨æ·è®¾ç½®"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "ç¼è¾é¢è²",
        editColorant: "ç¼è¾è²æµ",
        emptyColorant: "æçè²æµå¿«ç¨å®äº",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formula for master product",
        formulaForMasterProductWithParam: "Formula for master product %{productName}",
        isNotAvailable: "ä¸å¯ç¨",
        noBaseSelected: "å¿å¡«",
        noColorantsSelected: "æ²¡æéæ©è²æµ",
        noFandeckSelected: "éè¦fandeck",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "äº§åä¸ºå¿å¡«é¡¹",
        productPreview: "ç¤ºä¾äº§å",
        saveCustomRecipe: "ä¿å­å®¢æ·è¦æ±",
        saveIsNotAvailable: "ä¸è½ä¿å­",
        showSiblingProducts: "Show sibling products",
        siblingProducts: "Sibling products by master product"
    },
    customersTab: {
        addCustomer: "æ·»å ",
        additionalSettings: "Additional Settings",
        adress: "å°å",
        createAndSelect: "Add and select",
        createNewCustomer: "Create new customer",
        editCustomer: "ç¼è¾å®¢æ·",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Identification number",
        information: "Contact Information",
        listOfCustomers: "List of customers",
        rabat: "ææ£",
        selectCustomer: "Select customer",
        spentLastMonth: "ä¸ä¸ªææ¶è´¹",
        spentMoney: "æ¶è´¹æ°é¢",
        typeOfMargin: "ä¿è¯éç±»å",
        zipCode: "é®ç¼"
    },
    dialog: {
        cheaperColorSearch: "Cheaper color search is in progress",
        competitiveColorSearch: "Competitive color search is in progress",
        reallyChangeModule: "æ¨ç¡®å®è¦æ´æ¢æ¨¡ååï¼",
        reallyCloseRedlike:
            "Do you really want to close %{name}? All %{name} panels will be closed, unsaved changes will be lost.",
        reallyDeleteOrder: "æ¨ç¡®å®è¦å é¤æ­¤ä½ä¸åï¼æå³æ­¤è®¢åçæææ°æ®é½å°ä¸¢å¤±ã",
        reallyRebootPC: "ä½ ç¡®å®è¦éå¯è¿å°çµèåï¼ææå±å¹é½å³é­ï¼æªä¿å­çæ°æ®å°ä¸¢å¤±ã",
        reallyRestartRedlike: "ä½ ç¡®å®è¦éå¯%{name}åï¼ å°è¢«å³é­ï¼æªä¿å­çæ°æ®å°è¢«ä¸¢å¤±ã",
        reallyShutdownPc:
            "Do you really want to shut down this computer? All %{name} panels will be closed, unsaved changes will be lost.",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Tint only maximal tintable amount",
        2: "Allow manual dispensing using scale for amounts over the maximal tintable amount",
        3: "Refill during tinting (split amount into smaller chunks)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Fandeck name"
    },
    editFormulaRgbModal: {
        apply: "åºç¨",
        blue: "èè²",
        green: "ç»¿è²",
        modalLabel: "ç»¿è²",
        red: "çº¢è²",
        tryGenerateRgb: "Try to generate RGB by colorant amounts"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Close formula tab automatically",
        allowBarcodes: "Allow barcodes",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Allow customers",
        allowDeleteConfirmation: "Allow delete confirmation",
        allowDiskSpaceNotification: "Allow disk space notification",
        allowDispensing: "Allow dispensing",
        allowFileTransfer: "Allow automatic file transfer",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Allow formula status panel",
        allowInternalNotes: "Allow internal notes",
        allowLight: "Allow %{name}",
        allowOrderNotificationModal: "Show new order notifications",
        allowOrdering: "åè®¸è®¢è´­",
        allowPricing: "Allow pricing",
        allowPrint: "Allow print",
        allowProductPreviewImage: "Allow product preview image during dispensing",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Allow searching for cheaper colors",
        allowSound: "Allow sound order notification",
        allowSpectro: "Allow spectro",
        allowTabs: "Allow tabs",
        applyZoom: "åå",
        automaticLogout: "Automatic logout",
        barcodeScan: "Barcode Scan",
        canisterBarcode: "Canister Barcodes",
        canisterLevel: "Canister Level",
        changelog: "Changelog",
        closeTab: "Close Tab",
        colorDifference: "Color difference",
        colorPanelNavItem: "Color Palette",
        competitiveColorSearch: "Competitive color search",
        customBanner: "Custom banner",
        customCurrencyFormat: "Currency format",
        customDateFormat: "Date format",
        customNumberFormat: "Number format",
        customTimeFormat: "Time format",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Show discount",
        dispensingHistory: "Disp. History",
        dispensingNotes: "Allow dispensing notes",
        enableCustomers: "Enable customers",
        enableDeleteConfirmation: "Enable delete confirmation",
        enableDispensing: "Enable dispensing",
        enableLight: "Enable %{name}",
        enableMarginMarkup: "Enable margin or markup",
        enableNotes: "Enable notes",
        enableOrdering: "å¯ç¨è®¢è´­",
        enableProductPreviewImage: "Enable product preview image",
        enableSpectro: "Enable spectro",
        enableVirtualKeyboard: "Allow virtual keyboard",
        environmentsSettings: "ç¯å¢è®¾ç½®",
        exportTranslationKeys: "å¯¼åºç¿»è¯é®",
        formulaNotes: "Allow formula notes",
        hintTooltips: "Hint tooltips",
        image: "å¾ç",
        keyboardShortcuts: "Keyboard Shortcuts",
        languageBased: "Language based",
        lockYourComputer: "Lock your computer",
        machineReset: "Machine Reset",
        manageTranslations: "ç®¡çç¿»è¯",
        margin: "Only margin",
        markup: "Only markup",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "Maximum number of formula tabs",
        memoryTabs: "Store recently opened tabs",
        moreInfo: "Color + image + more info",
        navigationItems: "Navigation items settings",
        newTab: "New Tab",
        numberOfPriceGroups: "Number of price groups",
        order: "Order",
        orderId: "Order ID",
        ordersHistory: "History of orders",
        overwriteLastTab: "Overwrite last formula tab",
        priceCalculation: "Price calculation",
        priceDefBothPurchasePrimary: "Both, purchase primary",
        priceDefBothSellPrimary: "Both, sell primary",
        priceDefPurchaseOnly: "Purchase price only",
        priceDefSellOnly: "Sell price only",
        priceDefinition: "Price definition",
        priceGroupsEnabled: "Enable price groups",
        runLightAtStartUp: "Run %{light} at startup",
        screenSaverTimeout: "Screensaver timeout",
        selectedSpectro: "Selected %{spectro} spectro.",
        selectedSpectroNone: "No spectro selected.",
        setAutomaticClientStart: "Run %{name} at computer startup",
        setCustomHomeButton: "Set home button action",
        setDecimalPlaces: "è®¾ç½®éå·åä½æ°",
        setFormulaPreview: "è®¾ç½®éæ¹ç¤ºä¾",
        setFormulaUnit: "è®¾å®éæ¹åä½",
        setFts: "Use fulltext search",
        setInfoItemInRgb: "Set information visible in the formula color preview",
        setKeyboardShortcuts: "Set keyboard shortcuts",
        setKioskMode: "è®¾ç½®ä¿¡æ¯äº­æ¨¡å¼",
        setKioskModeOff: "å³é­ä¿¡æ¯äº­æ¨¡å¼",
        setKioskModeOn: "å¼å¯ä¿¡æ¯äº­æ¨¡å¼",
        setNavigationItems: "è®¾å®æå¯»é¡¹ç®",
        setNavigationItemsList: "Set visibility and order of navigation items",
        setOrderSearchItems: "Set order search parameters",
        setRounding: "è®¾ç½®å®ææ¶é´",
        setSearchParameters: "Set formula search parameters",
        setTabLimit: "Set tab limit",
        setYourLanguage: "è®¾ç½®è¯­è¨",
        setZoom: "è®¾ç½®åæ°",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "This setting cannot be changed because the place can dialog has been deactivated in Machine Settings",
        sortItems: "Sort navigation items",
        startDispensing: "Start dispensing",
        stir: "Stir"
    },
    error: {
        errorDetail: "éè¯¯æ¥åç»è",
        errorOccurred: "åçæå¤çéè¯¯æ¶æ¯ã éè¿ %{0}å¨æä»¬çæ¯ææå¡ä¸­çè¨ï¼æä»¬å°å°½å¿«ä¸æ¨èç³»ã",
        hideDetail: "éèç»è"
    },
    favoritesTab: {
        addFolder: "æ·»å èµæå¤¹",
        closeTabToLoadFormula: "å³é­ä¸ä¸ªéæ¹ä»¥æå¼ä¸ä¸ªæ°éé¡¹å¡ã æ¨å·²è¾¾å°éé¡¹å¡çæå¤§æ°éã",
        deleteFolder: "å é¤èµæå¤¹",
        editFolder: "ç¼è¾èµæå¤¹",
        favoriteFormulas: "å¸¸ç¨éæ¹",
        formulaNotes: "Formula notes",
        message: {
            formulasFromFolder: "æä»¶å¤¹ä¸­çéæ¹",
            moveAllFormulas: "å°ææéæ¹ç§»å°ç¶æ°æ®åº",
            removeAllFormulas: "å é¤æ­¤æä»¶å¤¹ä¸­çææéæ¹",
            wantToDeleteFolder: "æ¨ç¡®è®¤è¦å é¤è¿ä¸ªæä»¶å¤¹åï¼"
        },
        newFolder: "æ°æä»¶å¤¹",
        packages: "åè£æ¹å¼",
        pricePerPackage: "æ¯ä»¶ä»·æ ¼",
        regularPrice: "æ­£å¸¸ä»·æ ¼",
        removeFromFavorites: "ä»å¸¸ç¨ä¸­ç§»é¤",
        specialPriceOff: "ç¹ä»· %{number}% çææ£",
        specialPriceVIP: "VIPç¹æ ä»·æ ¼"
    },
    fileTransfer: {
        afterImport: "After import",
        alreadyExists: "Task for given type and format already exists",
        customFormulaSimple: "Custom formula simple",
        direction: "Direction",
        exportTask: "File export task",
        fileTransferNotification: "File transfer notification",
        flashMessage: "Flash message",
        importTask: "File import task",
        noInformation: "No information",
        protocol: {
            folder: "Folder",
            ftp: "FTP protocol",
            ftps: "FTPS protocol",
            redlikeStorage: "%{softwareName} FTP storage protocol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocol checking files in defined local folder.",
            ftp: "Protocol checking files in remote FTP folder using standard FTP connection.",
            ftps: "Protocol checking files in remote FTPS (FTP-SSL / FTP Secure) server using standard FTP connection.",
            redlikeStorage: "Protocol checking files in %{softwareName} storage."
        },
        remoteFolder: "Remote folder",
        startType: "Start type",
        statusbar: "Statusbar information",
        testConnection: "Test connection",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Consumption type",
        filter: "Filter",
        from: "From",
        to: "To"
    },
    findText: {
        findTextTitle: "Find text",
        removeMarks: "Remove marks",
        search: "Search word"
    },
    flashMessage: {
        VMNotAllowed: "VM not allowed",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Database autologin failed.",
        autotaskDuplicateName:
            "Database integrity error: %{0} item with %{1} %{2} already exists, please use different %{3}",
        barcodeIsUsed: "The barcode is already used.",
        barcodeNotFound: "æ¾ä¸å°æ¡å½¢ç ",
        bugReportSent: "Your bug report was sent.",
        cannoctConnectToServer: "æ æ³è¿æ¥å°%{name}æå¡å¨ï¼Redlik",
        cannotWriteLicense: "Cannot write license",
        clientConnectionRejected: "è¿æ¥è¢«æç»",
        clientNotLoggedIn: "å®¢æ·æªç»å½",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty:
            "No competitive colors could be found. Change searching parameters or select a different color.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Computer backdated",
        connectionFailed: "Connection test failed: %{0}",
        connectionSuccess: "Connection test was successful",
        corruptedLicenseFile: "License file corrupted",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "The customer was not found",
        dataNotAvailable: "æå¡å¨æ æ³è¿æ¥å°æ°æ®åº",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "ä¸æ¬¡æå¡å¨æä½æé´åçæå¤éè¯¯æ¶æ¯",
        deleteAll: "Delete all",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "You can disable the winter plugin by using the drop-down list on the right side of the tab navigation",
        duplicateBarcode: "Duplicate barcode already exists.",
        duplicateName: "åç§°éå¤å·²ç»å­å¨",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "License has expired",
        exportSuccess: "Data have been exported successfully",
        fandeckExist: "This custom fandeck name already exists.",
        featureNotAutorized: "Feature not authorized",
        fileExportComplete: "File was successfully exported.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "File not provided or is empty.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Could not process data in file, file is not valid.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Could not detect version of file.",
        filetransferNoData: "No database connection, check settings",
        formulaDataUnavailable: "Formula data is not available",
        helperDefaultMessage: "An unexpected error occurred during the last Helper Server action",
        helperServerError: "Helper Server error",
        importAborted: "Import process has been aborted",
        importSuccess: "Data have been imported successfully",
        incompatibleBaseCan: "åºæ¬ç½ä¸äº§åï¼åºæ¼ååè£ä¸å¼å®¹",
        incorrectPassword: "Your old password is not correct. Please enter a correct one.",
        invalidCurrency: "Currency code is not valid. Euro is set as a default currency.",
        invalidDatabaseName: "æ æçæ°æ®åºåç§°",
        invalidEmail: "æ¨ççµå­é®ä»¶æ æ",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Invalid company-user key",
        invalidLicenseFile: "Invalid license file",
        invalidLicenseIdentificationKeys: "æ¨çè®¸å¯è¯æ è¯å¯é¥æ æ",
        invalidLicenseKey: "æ¨çè®¸å¯è¯æ æ",
        invalidLicenseProduct: "License file does not match the product",
        invalidRccResponse: "An unexpected error occurred during processing of the last RCC response",
        invalidServerResponse: "å¨å¤çä¸ä¸ä¸ªæå¡å¨æä½æé´åçäºæå¤çéè¯¯æ¶æ¯",
        invalidUrl: "æå¡å¨ç½åæ æ",
        itemNotFound: "æ¾ä¸å°è¯¥é¡¹ç®",
        keyboardShortcutUsedInModal:
            "This keyboard shortcut cannot be used in the modal window. Please close the modal window.",
        keyboardShortcutValidation: "You cannot have the same keyboard shortcut for two different actions",
        licenseHasBeenRevoked: "Your license has been revoked. To renew it, please contact your software supplier.",
        licenseProlongationNeeded: "License prolongation needed (connect PC to the Internet to obtain new license)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Originally licensed on a different computer",
        logFileArchiveDownloadComplete: "Downloading of log archive was successfully completed",
        loginError: "ç»å½æ¶åçæå¤éè¯¯æ¶æ¯",
        logoutError: "éåºæé´åçæå¤éè¯¯æ¶æ¯",
        machineIsConnecting: "Machine is connecting, please wait",
        machineIsNotConnected: "æ¶æè°è²æºæªè¿æ¥å°%{name}æ§å¶ä¸­å¿ã æ£æ¥RCCéç½®",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "å³é­ä¸ä¸ªæ ç­¾ä»¥æå¼ä¸ä¸ªæ°çã æ¨å·²è¾¾å°æå¤§æ°éã",
        noTemplate: "Print cannot be carried out as there are no templates available.",
        openNewTab: "Please open a new formula tab to load formula using barcode",
        orderAlreadyAcquired: "Order has been already acquired, it has to be released first",
        orderCreated: "å§æå·²æååé",
        passwordIsNotUnique: "Old password must differ from the new one.",
        printCannotBeCarriedOut: "Print cannot be carried out as the printer name is invalid.",
        problemWithFileExport: "An error occurred while saving the file to disk.",
        productFileWarning: "Product file is only available online.",
        productNotLicensed: "Product is not licensed",
        rccDefaultMessage: "ä¸æ¬¡RCCåçº§æé´åçæå¤éè¯¯æ¶æ¯",
        rccError: "RCCéè¯¯",
        rccNeedRestart: "éæ°å¯å¨æ¨çRCC",
        restoredSettings: "Settings have been restored.",
        revokedLicense: "License was revoked",
        runningOutOfSpace: "The computer is running out of free space.",
        savedFormulaToHistory: "Formula was successfully saved into history.",
        savedLogArchive: "Log archive was successfully saved into your directory.",
        scanning: "Scanning in progress",
        serverError: "æå¡å¨éè¯¯",
        setClientIdentifier: "Please set your client identifier",
        showLess: "Show less",
        showMore: "Show more",
        spectroIsDisconnecting: "Spectro is disconnecting, please wait",
        spectroIsNotConnected: "æ­¤æ¶æ¨çåè°±ä»ªå°æªè¿æ¥æ£æ¥RCCéç½®ã",
        spectroIsNotSelected: "æ¨çåè°±ç®åæ²¡æè¢«éæ©ã æ£æ¥RCCéç½®ã",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Unknown error: %{0}",
        userAlreadyLoggedIn: "æ¨å·²ç»ç»å½ï¼",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Could not connect to Web Api server",
        webApiInternalError: "Web Api server internal error",
        webApiInvalidUser: "Web Api server invalid user",
        webApiNoLicenseAvailable: "Web Api server no license available",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Wrong format of %{0} input.",
        wrongRccVersion: "Please check the version of your RCC. Your client is compatible only with RCC %{0}."
    },
    footer: {
        aboutApplication: "About application",
        activeUser: "Active user",
        logOut: "æ³¨é",
        machineErrors: "æºå¨éè¯¯"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "All units available in the database",
        allowCustomFormulas: "Allow custom formulas",
        allowCustomPackageSize: "Allow custom package size",
        allowFormulaAutomaticNaming: "Allow automatic naming",
        automaticNaming: "Formula automatic naming",
        basePanelSize: "Set size of base panel",
        bippPanelSize: "Set size of base in product package panel",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "Color palette",
        colorPreviewAsImage: "Color preview as image",
        colorPreviewResizable: "Resizable color preview",
        competitiveColorSearch: "Competitive color search",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Custom formulas",
        customPackageSettingsUnitGrav: "Custom package settings gravimetric unit",
        customPackageSettingsUnitVol: "Custom package settings volumetric unit",
        customPackageSize: "Custom package size",
        customUnits: "Choose custom units",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "ç¼è¾è²æµ",
        editColorantsAllowed: "åè®¸ç¼è¾è²æµ",
        fandeckPanelSize: "Set size of fandeck panel",
        favoriteFormulas: "å¸¸ç¨éæ¹",
        formulaColorPreview: "é¢è²éæ¹ç¤ºä¾",
        formulaDataSettings: "Formula Data Settings",
        formulaPanel: "éæ¹çªå£",
        formulaPanelSize: "Set size of color panel",
        formulaSettings: "è®¾ç½®éæ¹",
        generateColorPreview: "Generate color preview",
        gravimetricOnly: "Gravimetric units only",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Use only image from local database",
        imagesOnline: "Primarily, try to open online image, if it fails, open local image",
        infoPanelResizable: "Resizable more info panel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Unit depends on the selected product",
        productFilesDialog: "Show dialog to open local file or online file",
        productFilesLocal: "Use only product files from local database",
        productFilesOnline: "Primarily, try to open online product file, if it fails, open local file",
        productPanelSize: "Set size of product panel",
        searchPanelQuickSelect: "Quick select",
        setAdditionalFormulaPanel: "Set additional formula panel",
        setCompetitiveColorSearch: "Enable competitive color search",
        setInitialFormulaPanel: "åå§éæ¹çªå£è®¾ç½®",
        setMaxToleranceForCompetitiveColors: "Set max tolerance for competitive color search",
        setNumberOfCompetitiveColors: "Set number of competitive master colors",
        setSearchPanel: "Set search panel",
        setVisibilityAndOrder: "Set visibility and order of various formula data",
        setVisibleUnit: "è®¾ç½®å¯è§åä½",
        showColorPreview: "æ¾ç¤ºç¤ºä¾é¢è²",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Colorant panel sorting",
        useBase: "Use selection item for base",
        useBaseInProductPackage: "Use selection item for base in product package",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Use selection item for product",
        useProductCode: "Use product code",
        useProductGroups: "Use product groups",
        volumetricOnly: "Volumetric units only"
    },
    general: {
        accepted: "Accepted",
        active: "æè¿çæ´»å¨",
        actual: "å½å",
        actualLevel: "å½åæ°´å¹³",
        add: "æ·»å ",
        addColorant: "æ·»å è²æµ",
        addColorantForPackage: "Add colorant for package",
        addFile: "Add file",
        all: "å¨é¨",
        amount: "Amount",
        applyNow: "Apply now",
        attachments: "Attachments",
        automaticCorrection: "Automatic correction",
        automatically: "Automatically",
        available: "Available",
        back: "Back",
        base: "åºç¡æµ",
        baseInProductPackage: "Base in product and package",
        batchNumber: "Batch number",
        bottom: "Bottom",
        buildingSite: "Building site",
        calculate: "Calculate",
        can: "ç½",
        canSize: "ç½è£è§æ ¼",
        cancel: "åæ¶",
        canister: "Canister",
        canisterId: "ç½å·",
        canisterIndex: "Canister Index",
        canisters: "ç½",
        cap: "éé¨",
        capacity: "å¯å®¹çº³æ°",
        channels: "é¢é",
        choose: "Choose",
        city: "åå¸",
        clean: "Clean",
        clear: "éæ",
        client: "å§æäºº",
        close: "å³é­",
        closeAll: "Close all",
        collapseAll: "Collapse all",
        color: "é¢è²",
        colorCode: "Color code",
        colorFile: "Colorfile",
        colorName: "Color name",
        colorPreview: "é¢è²é¢è§",
        colorant: "è²æµ",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Colorant package",
        colorants: "è²æµ",
        colors: "Colors",
        company: "Company",
        competitiveColor: "Competitive color",
        confirm: "ç¡®è®¤",
        confirmDeletion: "Do you really want to delete this item permanently?",
        confirmHelpSettings: "Do you really want to save the form and leave the fields empty?",
        connect: "é¾æ¥",
        continue: "ç»§ç»­",
        correction: "Correction",
        country: "Country",
        created: "Created",
        creationDateOf: "Creation date of",
        criticalLevel: "ä¸´çæ°´å¹³",
        currency: "Currency",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "å®¢æ·",
        customData: "Custom data",
        customFandeck: "èªå®ä¹é¢è²èå´",
        customFormula: "Custom formula",
        customPackage: "Custom",
        customPackageSettings: "Custom package settings",
        customer: "å®¢æ·",
        customerVersion: "å®¢æ·çæ¬",
        customers: "å®¢æ·",
        database: "æ°æ®åº",
        date: "Date",
        default: "Default",
        delete: "ä¿®æ¹",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "åå®¹æè¿°",
        disconnect: "æ­å¼è¿æ¥",
        discount: "Discount",
        discover: "åç°",
        dispense: "è°é",
        dispensing: "è°é",
        doNotShowAgain: "Do not show this message again.",
        downloadingFile: "Downloading files",
        edit: "ç¼è¾",
        email: "é®ä»¶",
        enabled: "å¼æº",
        error: "Error",
        expandAll: "Expand all",
        exportData: "Export data",
        exportPdf: "Export PDF",
        fan: "é¢è²èå´",
        fandeck: "é¢è²èå´",
        fandeckCode: "Fandeck code",
        fandeckName: "é¢è²èå´åç§°",
        fandecks: "Fandecks",
        favorite: "å¸¸ç¨ç",
        fileTransfer: "File transfer",
        filling: "Filling",
        fillingDate: "Filling date",
        find: "Find",
        finish: "Finish",
        finishedCorrection: "Finished correction",
        formula: "éæ¹",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "æ«æQRç ",
        gravimetric: "Gravimetric",
        historical: "Historical",
        history: "History",
        hours: "Hou.",
        id: "ID",
        images: "Images",
        in: "In",
        index: "Index",
        insertBarcode: "è¾å¥æ¡å½¢ç ",
        install: "Install",
        installed: "Installed",
        instructions: "Instructions",
        internalNote: "Internal note",
        interval: "Interval",
        ip: "IPå°å",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limit",
        load: "Load",
        loadFormula: "ä¸è½½éæ¹",
        localVersion: "æ¬å°çæ¬",
        machine: "æºå¨",
        manualCorrection: "Manual correction",
        manually: "Manually",
        margin: "ä½é",
        markup: "Markup",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "æå¤§æ°´å¹³",
        maxValue: "Max value",
        maximum: "æå¤§",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "æå°",
        minutes: "Min.",
        missingItem: "ç¼ºå¤±çé¡¹ç®",
        missingRequiredItems: "All required items (marked with an asterisk) must be filled in",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "More",
        moreInfo: "More info",
        moveDown: "åä¸",
        moveUp: "åä¸",
        myOrders: "My Orders",
        name: "åç§°",
        nameTitle: "åç§°",
        new: "New",
        next: "Next",
        no: "ä¸",
        noColorantsAvailable: "No colorants available",
        noFormulas: "No formulas yet",
        noPricesAvailable: "No prices available",
        nominalAmount: "Nominal amount",
        notAvailable: "Not available",
        note: "å¤æ³¨",
        numberOfCanisters: "ç½æ°",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Number of labels",
        numberOfPackages: "Number of packages",
        off: "å³",
        ok: "å¥½",
        on: "å¼",
        onFocus: "On focus",
        open: "Open",
        operator: "Operator",
        options: "éé¡¹",
        order: "Order",
        other: "å¶ä»",
        otherError: "å¶ä»éè¯¯",
        out: "Out",
        overwrite: "Overwrite",
        package: "åè£",
        packagePreview: "Package preview",
        partialUpdates: "Partial updates",
        phone: "çµè¯",
        pleaseWait: "Please wait",
        previous: "Previous",
        price: "ä»·æ ¼",
        priceGroup: "Price group",
        print: "æå°",
        printTask: "Print task",
        processingStep: "Processing %{step}",
        product: "äº§å",
        productCode: "Product code",
        productName: "Product name",
        products: "äº§å",
        pump1: "Pump 1",
        pump2: "Pump 2",
        purchasePrice: "Purchase price",
        purge: "æ¸é¤",
        qualityControl: "Quality control",
        quantity: "æ°é",
        quantityQty: "QTY",
        quickTint: "æå¨è°è²",
        rccIsNotAvailable: "æ æ³ä½¿ç¨RCC",
        rccIsNotConnected: "RCC is not connected",
        rccNotLicensed: "RCC is not licensed",
        reconnect: "éæ°è¿æ¥",
        refill: "åæ¬¡æ·»å ",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Reset",
        restart: "Restart",
        restore: "Restore",
        retint: "Retint",
        revision: "Revision",
        safetySheet: "Safety sheet",
        save: "ä¿å­",
        saveAs: "Save as",
        saveToDispensingHistory: "Save to history",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "å¨é",
        selectChannels: "éæ©æ¸ é",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Sell price",
        settings: "è®¾ç½®",
        shelf: "æ¶",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Size",
        skip: "Skip",
        smartPurge: "Smart purge",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "ååååº¦è®¡",
        standardFormula: "Standard formula",
        status: "Status",
        street: "è¡é",
        sum: "Sum",
        summary: "Summary",
        sync: "Sync",
        technicalSheet: "Technical sheet",
        templates: "æ¨¡æ¿",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "To Dispense",
        top: "Top",
        total: "Total",
        totalAmount: "Total amount",
        totalBaseAmount: "Total base amount",
        totalColorantAmount: "Total colorants amount",
        type: "Type",
        ufiCode: "UFI code",
        ufiThreshold: "UFI threshold",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Unit",
        units: "Units",
        unknown: "Unknown",
        update: "Update",
        updated: "Updated",
        user: "ç¨æ·",
        value: "Value",
        vat: "VAT",
        verified: "Verified",
        version: "çæ¬",
        versionId: "Version ID",
        versionStructure: "Version structure",
        volumetric: "Volumetric",
        warning: "è­¦å",
        warningLevel: "è­¦åæ°´å¹³",
        withoutName: "(without name)",
        workingProperly: "Working properly",
        yes: "æ¯",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the brush container automatically at the defined time. The dispenser operator needs to remove, clean, and then return the brush container manually.",
            capMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the cap automatically at the defined time. The dispenser operator needs to clean the autocap manually after it opens.",
            cleanAll:
                "Set this autotask to have the dispenser perform the action for cleaning all channels automatically at the defined time.",
            cleanChannels:
                "Set this autotask to have the dispenser perform the action for cleaning specific channels automatically at the defined time.",
            computerReboot: "Set this autotask to have the computer rebooted automatically at the define time.",
            computerShutdown: "Set this autotask to have the computer turned off automatically at the define time.",
            dispenserCleaning:
                "Set this autotask to have %{name} request the action for cleaning the dispenser automatically at the defined time. The dispenser operator needs to clean the machine with a cloth manually.",
            humidifierWaterLevelMaintenance:
                "Set this autotask to have %{name} request the action for refilling the humidifier automatically at the defined time. The dispenser operator needs to check and refill the water in the humidifier manually.",
            purgeAll:
                "Set this autotask to have the dispenser perform the action for purging all channels automatically at the defined time.",
            purgeChannels:
                "Set this autotask to have the dispenser perform the action for purging specific channels automatically at the defined time.",
            recirculateAll:
                "Set this autotask to have the dispenser perform the action for recirculating all channels automatically at the defined time.",
            recirculateChannels:
                "Set this autotask to have the dispenser perform the action for recirculating specific channels automatically at the defined time.",
            refillAll:
                "Set this autotask to have %{name} request the action for refilling all channels automatically at the defined time. The dispenser operator needs to refill colorants into all canisters manually.",
            refillCanisters:
                "Set this autotask to have %{name} request the action for refilling specific channels automatically at the defined time. The dispenser operator needs to manually refill colorants into canisters which do not meet the refill criterion.",
            smartPurgeAll:
                "Set this autotask to have the dispenser perform the action for smart purging all channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            smartPurgeChannels:
                "Set this autotask to have the dispenser perform the action for smart purging specific channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            stirAll:
                "Set this autotask to have the dispenser perform request the action for stirring all channels automatically at the defined time.",
            stirCanisters:
                "Set this autotask to have the dispenser perform request the action for stirring specific channels automatically at the defined time.",
            switchPlateMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the switch plate automatically at the defined time. The dispenser operator needs to remove, clean, and then return the switch plate manually."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Allows to add a new server manually if it could not be detected via the Discover function.",
            clientIdentifier:
                "The setting enables to identify this client if there are more clients connected to one server.",
            disconnect:
                "Information about the currently used server. The disconnect button allows to leave this server and switch to another one if available.",
            discover: "Discovers whether there are any other servers available in the network.",
            dropServers: "Deletes all previously detected servers from the list.",
            dropServersNotAvailable: "No server available",
            edit: "Allows to manually edit an already found server.",
            editDisabled: "No server selected."
        },
        continue: "Do you really want to continue?",
        driverSettings: {
            alfaRestApi: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Valid for all Alfa machines. Windows as well as Linux."
            },
            corobDsProxy: {
                machineType:
                    "Valid for generations Slave (D200, D600..), 4G (First One) and 5G (EvoFlx). DspProxy must be installed. Windows only."
            },
            corobEvoDriver: {
                machineType: "Valid for generation 5G (EvoFlx). EVOservice must be installed. Windows as well as Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "Select the dispenser configuration file. Default pre-set.",
                hldRootDir: "Select the main folder of HLD. Default pre-set.",
                machineType:
                    "Valid for Corob Flex (500, 520, 540) = former Lenteq. HLD must be installed. Windows only."
            },
            corobNextDriver: {
                machineType:
                    "Valid for generations Slave (D200, D600..), 4G (First One) and 5G (EvoFlx). NextDriver must be installed. Linux only."
            },
            dromontDDrv: {
                databasePath: "Path to the database file with calibration data. Default pre-set.",
                driverPath: "Path to the driver (D_DRV.exe). Default pre-set.",
                machineType:
                    "Indirect dispenser communication via set paths. Valid for generations V1 and V2. D_SET must be installed. Windows as well as Linux.",
                resultPath: "Path to the result file created after operation is over. Default pre-set.",
                serviceSoftwarePath: "Path to the Dromont service software (D_SET.exe). Defalut pre-set."
            },
            dromontDirect: {
                machineType:
                    "Direct dispenser communication. Valid for generations V1 and V2. D_SET must be installed. Windows as well as Linux.",
                rootDir: "Select the main Dromont folder, default pre-set."
            },
            dromontMisura: {
                driverPath:
                    "Path to the driver (MisuraRetail.exe) might change based on the Misura Retail version. Default pre-set.",
                extensionPath: "Path to communication file for service actions.",
                formulaPath: "Path to communication file for dispensing.",
                machineType: "Valid for generation V3. Dromont Misura must be installed. Windows only."
            },
            fastAndFluidIDD: {
                machineType: "Valid for all F&F machines. Windows only.",
                path: "Supported are IDD2 (HA 450, HA 650, X-smart, etc.) - must be licensed, IDD3 (HP 500, etc.), IDD4 (HA 180, HA 480, HA 680, Xprotint, etc.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Valid for all F&F machines. Windows as well as Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "Valid for all Hero machines. Windows only."
            },
            italtinto: {
                machineType: "Valid for all Italtinto machines. Wcal or ItaltintoCal must be installed. Windows only.",
                path: "Path to the adjusted Italtinto configuration file."
            },
            manualAdvanced: {
                machineType: "Valid for all manual machines, canister support included. Windows as well as Linux.",
                path: "Path to the configuration file with data about the dispenser and canisters."
            },
            manualSimple: {
                machineType: "Valid for all manual machines. Windows as well as Linux.",
                path: "Path to the configuration file with data about the dispenser."
            },
            none: {
                machineType: "No dispenser driver is selected."
            },
            santintColorLink3: {
                machineType: "Valid for all Santint machines. Windows only."
            },
            simulation: {
                machineType: "Valid for simulation dispenser if there is no real dispenser connected to the computer.",
                path: "Path to the simulation configuration file which must be in accord with the inserted database."
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "The overview of additional software plugins.",
            allowAutoCloseTab:
                "With the setting on, each formula tab will be closed automatically after the dispensing process has been finished.",
            allowAutomaticClientStart:
                "With this setting on, %{name} will start automatically after the start of the computer.",
            allowAutomaticPrint:
                "Label will be printed out automatically. Requires further setting about print before dispensing, after dispensing or both.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "On Formula panel, customers section will be accessible.",
            allowDispensing:
                "On Formula Panel, Dispense button will be activated along with Dispensing options in Machine Settings.",
            allowFileTransfer: "With this setting on, automatic data import and export by file transfer is available.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "On Formula Panel, Status panel will be activated.",
            allowLight: "%{name} will be accessible.",
            allowOrdering: "On Formula panel, Order button  will be activated.",
            allowPricing:
                "On Formula panel, the prices can be used. Visibility of prices is set in Available Prices. The prices are set in Price Settings.",
            allowProductPreviewImage: "The product image will be shown during dispensing.",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "On Formula Panel, the function to search for cheaper colors will be available.",
            allowSoundNotification: "Sound order notification plays musical melody when an order is received.",
            allowSpectro: "Spectro section will be accessible.",
            allowTabs: "With this setting on, working with multiple tabs simultaneously is available.",
            applyZoom:
                "Zoom enlarges or reduces the resolution. Keyboard shortcuts CTRL + and CTRL - are also applicable.",
            automaticLogout: "Set after how many minutes the automatic logout should be activated.",
            availableDatabases:
                "The settings enables to switch between databases if there are more than one available.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "The barcode testing environment serves to check the correctness of the scanned barcode by comparing it with the barcodes inserted in the database.",
            customBanner: "Set your own logo or banner and its position.",
            customCurrencyFormat:
                "Custom currency format can override default currency format based on selected language. ",
            customDateFormat: "Custom date format can override default date format based on selected language.",
            customNumberFormat: "Custom numer format can override default numer format based on selected language.",
            customTimeFormat: "Custom time format can override default time format based on selected language.",
            defaultPrinter:
                "The selected printer will be used when printing labels unless changed in Printer options window.",
            defaultTemplate:
                "The selected template will be used when printing labels unless changed in Printer options window.",
            deleteImportedData:
                "Deletes the previously imported custom data. The data can be imported again after deletion.",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "On Formula panel, dispensing notes section will be accessible.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "In %{name}, virtual keyboard will be available.",
            exportLocalSettings: "Exports the local settings of this computer.",
            exportStaticSql:
                "Exports the local settings of this computer. The exported file can be used to create a database with this setup.",
            exportTranslationKeys:
                "Export the newest translations and after translating, send them by email to your software supplier to have them imported.",
            favoriteButton: "Click to add the formula as favorite",
            formulaNotes: "On Formula panel, formula notes section will be accessible.",
            helpSettings: "The information is visible in the Help section on the quick access panel.",
            importCustomData: "Imports the local custom data based on the selected format.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Imports the local settings of this computer.",
            internalNote: "On Formula panel, internal note section will be accessible.",
            lockComputer:
                "The settings ensures that the environment of %{name} cannot be left - it enables the ultimate kiosk mode experience. Only applicable for Windows.",
            maxNumberTabs: "Tab limit sets how many formula tabs can be opened simulatenously.",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing:
                "The setting requires information about how many label copies should be printed out after the dispensing process.",
            printAsImage:
                "Print as image helps to solve the problems when standard printing way fails. Do not use it when standard printing works correctly. Compatible only with Linux.",
            printBeforeDispensing:
                "The setting requires information about how many label copies should be printed out before the dispensing process.",
            printEnabled:
                "This setting enables using printer with the software. Additional settings are in Print Settings.",
            printOnRequest: "On Formula panel, Print button will be activated.",
            printTaskVariable: "The print task is processed only if given print variable is available in print data",
            quickTintTemplate: "The selected template will be used when printing quick tint labels.",
            restoreLocalSettings: "Restores the local settings of this computer.",
            runLightAtStartUp: "%{light} will be started instead of %{name}.",
            screenSaverTimeout: "Set after how many minutes, the screensaver should be activated.",
            selectCustomDataFormat:
                "Select the format of the original data to be imported. Each format might require different additional files and settings.",
            setCustomHomeButton: "Home button in %{name} will redirect to the selected panel.",
            setFts: "Fulltext search allows full-text formula searching (also from the middle of the word, etc.).",
            setKeyboardShortcuts: "It is not possible to set the same keyboard shortcut for two different actions.",
            setNumberOfDecimalPlaces:
                "Rounding sets how many decimal places of colorants used in formula will be shown.",
            setOrderSearchParameters:
                "Order search defines which parameters are used when searching among orders. Only accessible in %{name}.",
            setOverwriteLastTab:
                "When choosing a new formula via global search whereas formula tab limit is reached, the last loaded formula tab will be overwritten by the new formula selection.",
            setSearchPanel: "Set your own visibility and order of items used when searching for a new formula.",
            setVisibilityAndOrder:
                "The selected navigation items will be visible in the quick access panel. The highest position here defines the leftmost position in the panel. Maximal allowed amount of navigation items is 6.",
            setYourLanguage: "Language change requires software restart.",
            settingsSearch: "Look up various settings if you are unsure where to find them.",
            showNewOrderNotifications:
                "Order notification is a pop-up window announcing that a new order has been received.",
            sorting:
                "Quick tint can have the canisters ordered according to the names of the colorants or by canister IDs.",
            turnOnKioskMode: "Kiosk mode on hides taskbar.",
            windowClosingRules:
                "The setting decides whether the quick tint window closes before or after the beginning of the dispensing process."
        },
        formulaSettings: {
            additionalFormulaTab: "The setting decides which panel will be shown when opening a new formula tab.",
            allowCustomFormulas: "Creating and searching for custom formulas will be activated.",
            allowCustomPackageSize: "On Formula panel, custom package size option will be activated.",
            allowEditingColorants:
                "On Formula panel, Edit colorant button will be activated (visible after selecting a color).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Set size of base on Formula panel",
            bippPanelSize: "Set size of base in product package on Formula panel",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "On Formula panel, the color preview will be the only visible information.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "On Formula panel, the color preview will be represented by image.",
            colorPreviewResizable: "Allows to resize color preview panel.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formula panel can have the colorants ordered according to the names or by amounts.",
            customCanOption: "Choose which measurement units can be used for custom package size on Formula panel.",
            customCanSettingsUnit:
                "Choose which measurement unit can be used as default for custom package settings on Formula panel.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation: "Enabling this setting will result in pop-ups to confirm deletion of an item.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Set size of fandeck on Formula panel",
            favoriteFormulasInitial: "When starting %{name}, Favorites panel will appear.",
            formulaAutomaticNaming:
                "A changed formula will be named automatically based on the performed colorant modifications.",
            formulaPanel: "When opening a new tab, Formula panel will appear.",
            formulaPanelInitial: "When starting %{name}, Formula panel will appear.",
            formulaPanelSize: "Set size of color on Formula panel",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "With this setting on, the color preview will be generated automatically. The resulting preview is not accurate.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "On Formula panel, the product image will be visible next to the color preview with the possibility to open the panel with more info.",
            images: "The setting defines the source of image files.",
            infoPanelResizable: "Allows to resize more info panel.",
            initialFormulaTab: "The setting decides which panel will be shown after %{0} starts.",
            moreInfo:
                "On Formula panel, the information panel will be visible next to the color preview and the product image preview.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "The setting enables to use product codes along with product names if available in the database.",
            productFiles: "The setting defines the source of product files which are available on Formula panel.",
            productGroups: "The setting enables hierarchy with product groups if available in the database.",
            productPanelSize: "Set size of product on Formula panel",
            searchNewFormula:
                "When opening a new tab, Search new formula will appear (contains information about last dispensed formulas and favorite formulas).",
            searchNewFormulaInitial:
                "When starting %{name}, Search new formula will appear (contains information about last dispensed formulas and favorite formulas).",
            searchPanelFormulaItems: "At least one of the formula items must be selected.",
            searchPanelProductItems: "Only one of the product items can be selected.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview:
                "On Formula panel, the selected data type will be always visible in the color preview.",
            setFormulaPreview:
                "The setting changes the position and display of color preview, package image and info data about the color.",
            setFormulaRGBPreviewVisibleInformation:
                "On Formula panel, the selected data type will be always visible in color preview.",
            setFormulaUnit:
                "On Formula panel, this setting decides which colorant unit is opened as first after selecting a color. Also applicable in Quick Tint.",
            setFormulaVisibilityAndOrder:
                "On Formula panel, the selected data will be visible in the section More info (only applicable if Set formula preview in Formula setting is Image or More info.",
            setMaxToleranceForCompetitiveColors:
                "Set the maximal Delta E (CIA 2000) tolerance for competitive color search.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "On Formula panel, this setting decides which colorant units are visible after selecting a color. Also applicable in Quick Tint.",
            showColorPreview:
                "On Formula panel, shows small color preview next to the color name when searching for a new formula.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Sum of colorant amounts is below base limit.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "The minimal tintable amount is the smallest colorant amount which can be dispensed as recommended by the laboratory.",
            checkOverfill:
                "The setting checks if there is enough space in the can for the colorants immediately after the amounts are set.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Colorant amount is below the minimal tintable amount.",
            dispensingWithErrorsEnabled:
                "If allowed, a warning message will appear in case of validation violations, but it will be possible to proceed to dispensing nonetheless.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Sum of colorant amounts is over maximal tintable amount.",
            overfill: "Overfill has been detected.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "I know the risks, continue"
        },
        help: "å¸®å©",
        helpLink: "Help Center",
        helper: {
            automaticallyCheckForUpdates:
                "It will be automatically checked if there is any update available for %{name} or database in the given time interval.",
            automaticallyDownloadUpdates:
                "If an update is available, it will be downloaded automatically without having to confirm.",
            automaticallyInstallNewDatabases:
                "If a hitherto absent DB is sent, it will be installed as a new DB. Afterwards, the DB can be used.",
            automaticallyInstallUpdates:
                "If an update has been downloaded, it will be installed automatically without having to confirm.",
            canBrowseChangeLog: "When updating the software, the official %{name} changelog will be available to see",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "The update will be installed during night if the computer is running."
        },
        licensing: {
            collect:
                "The logfiles will be downloaded to the selected location. The logfiles are required by the software supplied for bug analysis.",
            company: "The company which supplied the license.",
            computerID: "License identification to help the software supplier in case of required assistance.",
            email: "The email address of the license holder.",
            licenseUuid: "License identification to help the software supplier in case of required assistance.",
            name: "The name of the license holder.",
            openBugreport:
                "Please let us know if there is a bug in the software and send us a report with the bug description.",
            posInfoContactperson: "POS information about the owner to be printed on the label.",
            posInfoMachineInformation:
                "POS information about the dispenser to be printed on the label or recognized in the network.",
            posInfoPos: "POS information about the location to be printed on the label.",
            reactivation: "Reactivation or change of the current license.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registration information to identify the owner of the license.",
            registrationMachineInformation: "Registration information to identify the dispenser of the license.",
            registrationPos: "Registration information to identify the location of the license.",
            versionScope: "The software expiration limits.",
            versionType: "The software product type."
        },
        machineIsBusy: "Errors cannot be reset as the machine is busy.",
        machineSettings: {
            allowManualColorantAddition:
                "If the required colorant amount exceeds the maximal dispense amount, the setting allows to add it manually after dispensing.",
            autotasks:
                "Autotasks are automatic machine and computer maintenance events which can be set to be performed at certain time or time interval.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "The barcode is assigned to the canister in which the colorant is available. The barcode is necessary to ensure correct colorant refilling.",
            checkCanBeforeDispense: "The setting is only valid for Fast & Fluid simulation.",
            checkOverfill:
                "The setting checks if there is enough place in the can for the colorants before dispensing.",
            currentlySelectedMachine: "Provides information about the currently selected machine.",
            dispenseInvalidColorants:
                "The setting allows to dispense colorants which are not defined in the machine configuration by prompting manual colorant addition.",
            dispenserConfigurationBackup: "Download and save the current machine configuration to maintain a backup.",
            dispensingLogic:
                "Dispensing logic types can ensure different behaviour for each canisters when there is more colorant to be dispensed than allowed or desired. Additional behavior is set in Dispensing Settings.",
            enableTmc: "The setting enables sending data to TMC.",
            enableUserIdentification: "User has to log in before dispensing is allowed.",
            machineUnit: "Machine unit defines the unit of measurement of colorants in the canisters.",
            minDispensedAmount:
                "Min. dispensed amount sets how much colorant has to have been dispensed in order to consider the purge done (to avoid additional purge).",
            minimalDispenseAmount:
                "Minimal dispense amount is the smallest colorant amount which can be dispensed as recommended by the dispenser manufacturer. If violated, a warning message will appear (dispensing is still possible).",
            missingAutotaskCanisters: "There must be selected at least 1 canister",
            missingAutotaskChannels: "There must be selected at least 1 channel",
            missingAutotaskChannelsValue: "Volume of all selected channels must be filled in",
            missingAutotaskCleanTime: "Time of cleaning must be filled in",
            missingAutotaskName: "Name of the autotask must be filled in",
            missingAutotaskRecirculation: "Time and speed of recirculation must be filled in",
            missingAutotaskStirring: "Time and speed of stirring must be filled in",
            missingAutotaskVolume: "Volume of purge must be filled in",
            placeCanSensor:
                "The setting activates sensor for can placement - dispensing will not start unless the can has been placed properly.",
            placeCanSensorDelay:
                "Recommended setting linked to place can sensor. It ensures that the dispensing starts only after the defined time period during which the can has been placed properly.",
            purgeVolume: "Purge volume sets how much of colorant is being purged when performing smart purge.",
            rccUrl: "Redlike Control Center (RCC) is responsible for the communication with the dispenser.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "The setting activates sensor for can removal - dispensing is not considered done unless the can has been removed.",
            removeCanSensorDelay:
                "Recommended setting linked to remove can sensor. It ensures that the dispensing has been finished only after the defined time period during which the can has been removed.",
            skipPlaceCanDialog:
                "With this setting on, the dispenser will not wait when placing a can until the OK button is pressed, but will start the dispensing process automatically.",
            skipRemoveCanDialog:
                "With this setting on, the dispenser will not wait when removing a can until the OK button is pressed, but will consider the dispensing process finished automatically.",
            smartPurgeType:
                "The purge type can either consider dispensing only or dispensing plus other purging events when validating if smart purge is needed.",
            splitFormula:
                "If the required colorant amount exceeds the maximal dispense amount, the setting allows to dispense a chunk of colorant, refill the canister, and then continue dispensing the rest.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Base can has to be validated via barcode before dispensing is allowed. The setting ensures that the correct base is used.",
            validateColorantsDuringInit:
                "The machine configuration will be compared to the database each time when RCC is restarted. In case of mismatches, a notification occurs."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Opens a window with the possibility to enter the barcode manually.",
            canisterBarcodes:
                "Opens a window with canister barcode overview and the possibility to set canister barcode.",
            canisterLevel: "Opens a window with canister levels overview and the possibility to set canister level.",
            canisters: "Opens a panel with canister levels overview and the possibility to set canister level.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "Opens a panel with the possibility to search for a new formula in an electronic fandeck.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Opens a window with the overview of performed canister refills.",
            customFormula: "Opens a panel  with the possibility to create a new custom formula.",
            customers: "Opens a panel  with the overview of customers and the possibility to add/edit/delete them.",
            dispensingHistory: "Opens a panel with the overview of performed dispensings.",
            favorites: "Opens a panel with the possibility to select a favorite formula.",
            help: "Opens a window with customer service information if provided by the supplier.",
            hideItems: "Opens a window with the possibility to mark products and fandecks as hidden.",
            historyOfOrders: "Valid for %{name} exclusively, opens a panel with the overview of dispensed orders.",
            machineReset: "Starts dispenser reset.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "Orders which were sent from this computer",
            purge: "Opens a window with the possibility to set canister purge.",
            quickTint: "Opens a window with the possibility to perform manual dispensing.",
            searchFormula: "Opens a panel with the possibility to search for a new formula.",
            spectro: "Opens a panel with the possibility to measure with a spectro.",
            stir: "Opens a window with the possibility to set canister stirring.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "Orders which were received by this computer"
        },
        noHelpForLicense: "There is no help for your license available, ask your supplier to add it.",
        posInfo: {
            sync: "Synchronizes data with the section Registration"
        },
        poweredByDeso: "Powered by %{name}",
        priceSettings: {
            VatPrice: "Colorant VAT value in %.",
            VatPriceProduct: "The generic product VAT will be the same for every colorant. Set in %.",
            basePurchase: "Purchase price for base (incl. base exclusively).",
            basePurchasePriceProduct: "Purchase price for the package of the given base. Set in selected currency.",
            baseSell: "The selling price only for base (incl. base and margin/markup).",
            baseSellFull: "Sell full price for base.",
            cntName: "Defines which colorant the price is related to.",
            cntPurchase: "Purchase price for colorants (incl. colorants exclusively).",
            cntPurchaseByName:
                "Purchase price for colorants calculated individually for each (incl. colorants exclusively).",
            cntPurchasePricePerLiter: "The cost price of the colorant per liter (without margin or markup).",
            cntSell: "The selling price only for colorants (incl. colorants and margin/markup).",
            cntSellByName:
                "The selling price for all colorants used in the product calculated individually for each (incl. colorants and margin/markup).",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "The sell price of the colorant per liter (incl. colorant exclusively). Set in the selected currency.",
            cntVat: "Colorant VAT value set in %.",
            colorants:
                "The generic colorant prices will be the same for every colorant. This function is useful especially for setting the VAT.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "Currency code has to be in the official tree-letter form, for example EUR.",
            currencyNameNew: "The name of the currency, for example Euro.",
            currencyRateNew:
                "The currency rate towards the main currency, for example 25.855 CZK for 1 â¬. The rate needs to be edited continuously to be kept up-to-date.",
            currencyRoundingNew:
                "Rounding sets the smallest possible payable value of the currency, for example Euro has rounding 0.01 because the smallest possible value is 1 cent.",
            currencySymbolNew: "The official symbol of the currency, for example â¬ for Euro.",
            defaultPrice: "Colorant price set in the selected database (without VAT).",
            defaultPriceGroup: "Colorant price for price group set in the selected database (without VAT).",
            defaultVatPrice: "Colorant VAT set in the selected database.",
            discountHeader: "Discount substracts the the defined value from the purchase colorant price. Set in %.",
            discountHeaderProduct:
                "Discount substracts the the defined value from the product colorant price. Set in %.",
            export: "Export a file with the currently inserted prices. It can be imported again after having modified the prices.",
            import: "Import a correctly formated (exported) file to insert or modify the prices.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Choose which price calculation should be used for the definition of the final available price. Margin and markup add up to whereas discount substracts from the given sell price.",
            marginAll: "The price for margin/markup for multiple packages (incl. margin/markup).",
            marginHeader: "Margin adds the defined value up to the purchase colorant price. Set in %.",
            marginHeaderProduct: "Margin adds the defined value up to the purchase product price. Set in %.",
            marginPerPkg: "The price for margin/markup for one package (incl. margin/markup).",
            markupHeader: "Markup adds the defined value up to the purchase colorant price. Set in %.",
            markupHeaderProduct: "Markup adds the defined value up to the purchase product price. Set in %.",
            packagePricing: "Additional surcharge set individually for each package size.",
            packageSurcharge: "The generic package prices will be the same for every package surcharge.",
            priceDefinition: "The setting defines which price types are used when calculating final prices.",
            priceGroupNumber:
                "The setting defines how many price groups will be used. The range for individual price groups can be set in Default Values.",
            priceGroupPricePerLiter: "The colorant price used when calculating the price group price.",
            priceGroups:
                "Price groups displays the number of the relevant price group (the boundaries are set in the database or in generic pricing).",
            priceGroupsEnabled:
                "The setting allows you to work with price groups. Define the range in Default Values and individual prices in Colorant Pricing.",
            priceGroupsGeneric:
                "Price groups are pricing intervals of the final paint based on colorant prices in formula.",
            productBasePackageSellPrice: "Sell price for the package of the given base. Set in selected currency.",
            productBaseSellPrice:
                "Sell price for base calculated per liter (incl. base exclusively). Set in the selected currency.",
            productBaseVat: "Product base VAT value for the given package set in %.",
            productName: "Defines which product base the price is related to.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "Purchase price for all packages is used when dispensing custom packages.",
            productSize: "Defines which package of the given product base the price is related to.",
            productVat: "Product base VAT value set in %.",
            products:
                "The generic product prices will be the same for every product. This function is useful especially for setting the VAT.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "The selling price of multiple packages (incl. base, colorants, surcharge and margin/markup).",
            sellPricePerKg:
                "The selling price of the product per kilogram (incl. base, colorants, surcharge and margin/markup).",
            sellPricePerL:
                "The selling price of the product per liter (incl. base, colorants, surcharge and margin/markup).",
            sellPricePerPkg: "The selling price of one package (incl. base, colorants, surcharge and margin/markup).",
            setPriceTypesVisibilityAndOrder:
                "On Formula panel, the selected prices will be visible in the prices section. The highest position here defines the leftmost position in the section.",
            surchargeAll: "The price of an additional fee for multiple packages (incl. surcharge).",
            surchargePerPkg: "The price of an additional fee for one package (incl. surcharge).",
            tintPurchaseAll:
                "The purchase price for the whole tinting process of multiple packages (incl. colorans and surcharge).",
            tintPurchasePerPkg:
                "The purchase price for the whole tinting process of one package (incl. colorans and surcharge).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price for one package.",
            totalPurchaseAll:
                "The total purchase price of the product for multiple packages (incl. base and colorants).",
            totalPurchasePerKg: "The total purchase price of the product per kilogram (incl. base and colorants).",
            totalPurchasePerL: "The total purchase price of the product per liter (incl. base and colorants).",
            totalPurchasePerPkg: "The total purchase price of the product for one package (incl. base and colorants).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat:
                "On Formula panel, the price will be visible in both variations, with and without VAT, simultaneously.",
            withVat: "On Formula panel, all prices will be visible only with VAT included.",
            withoutVat: "On Formula panel, all prices will be visible only with VAT excluded."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Synchronizes data with the section POS Info"
        },
        searchingPleaseWait: "Please wait, the best match is being searched for",
        setupSteps: {
            customData: "Custom Data",
            machineType: "Machine Type",
            userPreferences: "User Preferences"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "When using profiled values, the measured results are recalculated to remove the filter effect. Allow this option for universal spectro measuring.",
            XRiteModelRM400: "No drivers required.",
            datacolorDiagnosticTile: "Datacolor use diagnostic tile",
            datacolorSilent: "Datacolor silent",
            measureModes: "Select supported gloss levels.",
            model: "Model",
            simulationPath: "Path to the simulation file. Default preset.",
            spectroType: "Official spectro driver has to be installed. Windows only.",
            spectroTypeCom:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeDataColorReader:
                "The computer has to have Bluetooth connection. The spectro has to be paired with the computer. Windows 10 with 2018 automn update required.",
            spectroTypeMinolta2XXXd:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeNotSelected: "Select your spectro model.",
            spectroTypeRM400: "No drivers required.",
            spectroTypeSimulation: "Lab values required to obtain simulation results. Windows as well as Linux.",
            spectroTypeXRite: "Windows only."
        },
        ufiCode: {
            baseUfiCodeValidation: "Base can UFI code has to be validated via barcode before dispensing is allowed.",
            enableUfiCodes:
                "UFI codes are used in EU and provide information about how hazardous a product is to environment.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label.",
            printUfiCodePercentage:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label along with its percentage representation.",
            ufiCodesByPercentage:
                "The UFI code which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            ufiCodesFromDatabase:
                "The UFI code from the main database given by the database administrator is used for printing.",
            ufiCodesFromLastFilling:
                "The UFI code from the last refill given by the operator is used for printing regardless the refilled amount."
        },
        userManagement: {
            add: "The setting adds a new user who can log in into the software. The user can have a barcode assigned and can be set to log in automatically after the software is started.",
            assignedGroups:
                "This defines what user groups the user belongs to. Various user groups distribute various privileges.",
            availableGroups:
                "This defines what user groups there are available for the user. Various user groups distribute various privileges.",
            loggedUserDelete: "Currently logged in user cannot be deleted."
        },
        visit: "Or visit",
        visitNoLicense: "For more information, please visit"
    },
    helpSettings: {
        customHelpLink: "Custom Help Center link",
        helpSettings: "Help settings",
        message: "Message"
    },
    helper: {
        automaticallyCheckForUpdates: "Check for updates automatically",
        automaticallyDownloadUpdates: "Download updates automatically",
        automaticallyInstallNewDatabases: "Automatically install new DBs",
        automaticallyInstallUpdates: "Automatically install updates",
        bugReport: "Bug report",
        canBrowseChangeLog: "Show online %{name} changelog.",
        collect: "Collect",
        collectLogFiles: "Collect log files",
        component: "Component",
        content: "Content",
        contentSize: "Content size",
        download: "Download",
        downloadLogFiles: "Download log files",
        downloadingData: "Downloading data",
        everyHours: "Every %{interval} hours",
        forceInstall: "Force to update",
        installDuringNight: "During night (%{start} - %{end}) every %{interval} hour",
        newVersion: "New version",
        notConnected: "Helper is not connected",
        openBugReport: "Open bug report",
        packageSize: "Package size",
        pleaseWait: "Please wait, this can take some time.",
        send: "Send",
        sendBugReportToCustomerService: "Send bug report to customer service",
        sendingReport: "Sending",
        subject: "Subject"
    },
    helperDialog: {
        1: "You can check for software or database updates.",
        2: "Continue with downloading the update packages?",
        3: "Continue with installation of downloaded update packages?",
        10: "Checking for software and database updates, please wait...",
        11: "There is an update available for your computer. Do you want to download it?",
        12: "There are no updates available for your computer.",
        14: "There was an error during checking for updates. %{0}",
        15: "Synchronizing zone databases, please wait...",
        20: "Downloading update package, please wait...",
        21: "Update package that was downloaded is now being verified, please wait...",
        22: "Downloading of update package has failed, do you want to retry?",
        23: "Downloading of update package has failed (file is malformed), do you want to retry?",
        24: "Proceed with update installation?",
        25: "Installation of automatic update will start in %{0}",
        26: "There is an update available for your computer. Do you want to download it?",
        27: "Proceed with update installation?",
        40: "Stopping applications and services, please wait...",
        41: "Copying new files, please wait...",
        42: "Starting applications and services, please wait...",
        43: "Finishing software update, please wait...",
        44: "Your software has been successfully updated.",
        45: "Do you want to retry installation? If you decide to retry make sure that software components are not currently in use.",
        46: "Reboot of PC is required to affect the changes, reboot will be done in %{0}",
        999: "Internal error occurred: %{0}",
        automaticInstallation: "Automatic update installation",
        btnAbort: "Abort",
        btnCancel: "Cancel",
        btnCheckUpdate: "Check for updates",
        btnContinue: "Continue",
        btnDownloadUpdate: "Download update",
        btnInstallUpdate: "Install update",
        btnOk: "OK",
        btnRetry: "Retry",
        btnSkip: "Skip",
        checkingForUpdates: "Checking for updates",
        downloadingFailed: "Downloading failed",
        downloadingPackage: "Downloading update package, please wait",
        finishingUpdate: "Finishing update",
        installingUpdate: "Installing update",
        internalError: "Internal error",
        rebootRequired: "Reboot is required",
        startingComponents: "Starting software components",
        stoppingComponents: "Stopping software components",
        synchronizingDatabases: "Synchronizing zone databases",
        updateAvailable: "Update available, select components to be updated",
        updateDownloaded: "Update has been downloaded",
        updateFailed: "Update process has failed",
        updateInstalled: "Update has been installed",
        verificationFailed: "Verification of update package failed",
        verifyingPackage: "Verifying downloaded package",
        yourSoftwareIsUpToDate: "Your software is up to date",
        yourSoftwareVersion: "Your software version: %{0}"
    },
    importData: {
        abortImportingData: "Abort importing",
        aborted: "Import was aborted.",
        backupLocalDB: "Backup local database",
        confirmRestore: "Do you really want to restore all local settings?",
        dataMissing: "Import failed because the source file didn't contain any data.",
        deleteImportedData: "Delete imported data",
        encodingFile: "File encoding",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Import failed because the source file seems to be damaged.",
        fileMissing: "Import failed because the source file doesn't exist.",
        format: "Format",
        formatPath: "Format path",
        headerMissing: "Import failed because the files header is missing.",
        import: "Import",
        importAborted: "Import aborted",
        importAborting: "Import aborting",
        importFailed: "Import failed because of an unexpected error.",
        importLocalSettings: "Import Local Settings",
        importPrices: "Import prices",
        imported: "Successfully imported",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Importing",
        noFormatAvailable: "No format available",
        processing: "Processing",
        processingCustomFormulas: "Processing custom formulas",
        processingCustomers: "Processing customers",
        productsFile: "Products file",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Import is under progress.",
        unknownFormat: "Import failed because the source file is of unknown format.",
        userFormulasFile: "User formulas file"
    },
    infoType: {
        baseDensity: "Base density",
        baseMass: "Base mass",
        baseUfiCode: "Base UFI code",
        baseVolume: "Base volume",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "BFS grade",
        colorLab: "Color Lab",
        colorRgb: "Color RGB",
        colorRgbHex: "Color RGB Hex",
        colorXyz: "Color xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Colorant mass",
        colorantUfiCodes: "Colorant UFI codes",
        colorantVolume: "Colorant volume",
        formulaDate: "Formula date",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formula more info",
        formulaMoreInfoInternal: "Formula more info internal",
        formulaMoreInfoPrint: "Formula more info print",
        hbw: "HBW",
        isPackageGravimetric: "Is package gravimetric",
        maxColorantMass: "Maximum allowed colorant mass",
        maxColorantVolume: "Maximum allowed colorant volume",
        nominalMass: "Package nominal mass",
        nominalVolume: "Package nominal volume",
        overfillDetected: "Overfill detected",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Total paint mass",
        totalPaintVolume: "Total paint volume",
        ufiCodesTable: "UFI codes table",
        verifiedFormula: "Verified formula",
        yValue: "Y value"
    },
    initialTab: {
        favoriteFormulas: "å¸¸ç¨éæ¹",
        lastDispensedFormulas: "æè¿ä½¿ç¨çéæ¹",
        searchNewFormula: "æç´¢æ°éæ¹"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "action",
        add: "add",
        addition: "addition",
        additional: "additional",
        address: "address",
        admin: "admin",
        advanced: "Advanced",
        after: "after",
        afterDispensing: "after dispensing",
        alfa: "Alfa",
        all: "all",
        allow: "allow",
        alphabetically: "alphabetically",
        amount: "amount",
        api: "api",
        ask: "ask",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "available price",
        backup: "backup",
        banner: "banner",
        barcode: "barcode",
        barcodes: "barcodes",
        base: "base",
        before: "before",
        begin: "begin",
        bfs: "bfs",
        bottom: "bottom",
        brand: "brand",
        brush: "brush",
        bug: "bug",
        button: "button",
        buy: "buy",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibration",
        can: "can",
        canHandling: "can handling",
        canister: "canister",
        canisterFilling: "canister filling",
        canisterLevels: "canister levels",
        canisters: "canisters",
        cap: "cap",
        center: "Center",
        centre: "Centre",
        change: "change",
        changelog: "changelog",
        channels: "channels",
        check: "check",
        chunk: "chunk",
        chunks: "chunks",
        city: "city",
        clean: "clean",
        cleaning: "cleaning",
        clientIdentifier: "client identifier",
        close: "close",
        closest: "closest",
        code: "code",
        collect: "collect",
        color: "color",
        colorLink3: "ColorLink3",
        colorPanel: "color palette",
        colorReader: "ColorReader",
        colorant: "colorant",
        colorantConsumption: "colorant consumption",
        colorantPrice: "colorant price",
        colorants: "colorants",
        colorix: "Colorix",
        colour: "colour",
        communication: "communication",
        compare: "compare",
        competitive: "competitive",
        computer: "computer",
        config: "config",
        configuration: "configuration",
        confirm: "confirm",
        confirmation: "confirmation",
        connection: "connection",
        contactPerson: "contact person",
        control: "Control",
        copies: "copies",
        corob: "Corob",
        cost: "cost",
        country: "country",
        create: "create",
        currency: "currency",
        current: "current",
        custom: "custom",
        customers: "customers",
        daily: "daily",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "Datacolor",
        date: "date",
        decimals: "decimals",
        default: "default",
        delay: "delay",
        delete: "delete",
        deletion: "deletion",
        deltaE: "delta e",
        device: "device",
        devices: "devices",
        diagnosticTile: "diagnostic tile",
        dialog: "dialog",
        direct: "direct",
        disconnect: "disconnect",
        discount: "discount",
        dispense: "dispense",
        dispenser: "dispenser",
        dispensing: "dispensing",
        down: "down",
        download: "download",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "edit",
        editor: "editor",
        email: "email",
        error: "error",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expiration",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "fandeck",
        fastFluid: "Fast & Fluid",
        file: "file",
        fill: "fill",
        fillToMax: "fill to max",
        find: "find",
        first: "first",
        flex: "Flex",
        folder: "folder",
        formula: "formula",
        formulas: "formulas",
        from: "from",
        fts5: "fts5",
        fullScreen: "full screen",
        fullText: "full-text",
        fulltext: "fulltext",
        g: "g",
        genericPricing: "generic pricing",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "help",
        helpCenter: "help center",
        hero: "Hero",
        history: "history",
        home: "home",
        host: "host",
        humidifier: "humidifier",
        iDD: "IDD",
        identification: "identification",
        image: "image",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "import",
        individually: "individually",
        info: "info",
        information: "information",
        initial: "initial",
        initialization: "initialization",
        initialize: "initialize",
        insert: "insert",
        install: "install",
        intellyPurge: "intelly purge",
        invalid: "invalid",
        ipAddress: "ip address",
        italtinto: "Italtinto",
        items: "items",
        keyboard: "keyboard",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kiosk mode",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "label",
        labels: "labels",
        language: "language",
        largo: "largo",
        last: "last",
        lenteq: "Lenteq",
        levels: "levels",
        license: "license",
        light: "Light",
        limit: "limit",
        link: "link",
        linux: "Linux",
        load: "load",
        lock: "lock",
        logFiles: "log files",
        logic: "logic",
        logo: "logo",
        lower: "lower",
        machine: "machine",
        machineConfiguration: "machine configuration",
        machineManagement: "machine management",
        machineName: "machine name",
        main: "main",
        maintenance: "maintenance",
        manual: "manual",
        manualAddition: "manual addition",
        manualDispensing: "manual dispensing",
        manualScan: "manual scan",
        margins: "margins",
        markups: "markups",
        mass: "mass",
        match: "match",
        measure: "measure",
        measurement: "measurement",
        measurementUnits: "measurement units",
        melody: "melody",
        message: "message",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minutes",
        misura: "Misura",
        ml: "ml",
        mode: "mode",
        model: "model",
        modification: "modification",
        modify: "modify",
        monthly: "monthly",
        moreInfo: "more info",
        movableTable: "movable table",
        move: "move",
        music: "music",
        myOrders: "my orders",
        name: "name",
        naming: "naming",
        nano: "Nano",
        navigation: "navigation",
        new: "new",
        nextDriver: "NextDriver",
        night: "night",
        nixPro: "Nix Pro",
        notes: "notes",
        notification: "notification",
        number: "number",
        off: "off",
        open: "open",
        order: "order",
        ordering: "ordering",
        overfill: "overfill",
        overview: "overview",
        overwrite: "overwrite",
        own: "own",
        pCPDriver: "PCPDriver",
        package: "package",
        packagePrice: "package price",
        packages: "packages",
        panels: "panels",
        parameter: "parameter",
        path: "path",
        pc: "pc",
        phone: "phone",
        phoneNumber: "phone number",
        picture: "picture",
        place: "place",
        placement: "placement",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "point of sale",
        popUp: "pop-up",
        pos: "pos",
        present: "present",
        preview: "preview",
        price: "price",
        priceExport: "price export",
        priceGroup: "price group",
        priceImport: "price import",
        prices: "prices",
        pricing: "pricing",
        primaryCurrency: "primary currency",
        print: "print",
        printer: "printer",
        printing: "printing",
        problem: "problem",
        product: "product",
        productPrice: "product price",
        profiledValues: "profiled values",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "purge",
        purgeType: "purge type",
        purgeVolume: "purge volume",
        quality: "quality",
        quick: "quick",
        quickTint: "quick tint",
        rM: "RM",
        raise: "raise",
        rcc: "rcc",
        reader: "reader",
        reboot: "reboot",
        receive: "receive",
        recirculate: "recirculate",
        recirculation: "recirculation",
        redlike: "Redlike",
        refill: "refill",
        registration: "registration",
        regular: "regular",
        removal: "removal",
        remove: "remove",
        report: "report",
        reset: "reset",
        resolution: "resolution",
        restart: "restart",
        rgb: "rgb",
        rights: "rights",
        rounding: "rounding",
        rules: "rules",
        sanTint: "SanTint",
        save: "save",
        scale: "scale",
        scan: "scan",
        scope: "scope",
        screen: "screen",
        screensaver: "screensaver",
        search: "search",
        secondaryCurrency: "secondary currency",
        select: "select",
        selectedFormula: "Selected formula",
        sell: "sell",
        sensor: "sensor",
        serialNumber: "serial number",
        server: "server",
        servers: "servers",
        service: "service",
        serviceAction: "service action",
        serviceActions: "service actions",
        serviceSoftware: "service software",
        serviceWindow: "service window",
        settings: "settings",
        shelf: "shelf",
        shortcuts: "shortcuts",
        shot: "shot",
        show: "show",
        shutDown: "shut down",
        shutdown: "shutdown",
        silent: "Silent",
        simple: "simple",
        simulation: "simulation",
        size: "size",
        skip: "skip",
        smartPurge: "smart purge",
        software: "software",
        softwareSupplier: "software supplier",
        sort: "sort",
        sound: "sound",
        spectro: "spectro",
        spectrophotometer: "spectrophotometer",
        speed: "speed",
        split: "split",
        start: "start",
        startup: "startup",
        statistics: "statistics",
        status: "status",
        stir: "stir",
        stirring: "stirring",
        street: "street",
        support: "support",
        surcharge: "surcharge",
        tab: "tab",
        tabs: "tabs",
        task: "task",
        template: "template",
        testing: "testing",
        time: "time",
        tintingManagementCenter: "tinting management center",
        to: "to",
        toDispense: "to dispense",
        tolerance: "tolerance",
        top: "top",
        total: "total",
        translation: "translation",
        turnOff: "turn off",
        turntable: "turntable",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "unit",
        up: "up",
        update: "update",
        url: "url",
        user: "user",
        userGroups: "user groups",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "VAT",
        validate: "validate",
        validation: "validation",
        version: "version",
        virtual: "virtual",
        volume: "volume",
        weekly: "weekly",
        window: "window",
        windows: "Windows",
        with: "with",
        without: "without",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y value",
        zipCode: "zip code",
        zoom: "zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "æ¿æ´»è®¸å¯",
        activateNewLicense: "Activate new license",
        checkLicenseKey: "è®¸å¯æ£æ¥è®¸å¯è¯å¯é¥",
        companyId: "å¬å¸åç§°",
        contactPerson: "èç³»äºº",
        copy: "å¤å¶",
        country: "å½å®¶",
        emptyCity: "City is a required information",
        emptyCountry: "Country is a required information",
        emptyName: "Shop name is a required information",
        enterIdentificationKeys: "è¾å¥æ¨çèº«ä»½æ°æ®",
        expirationDate: "Expiration date %{dateTime}",
        fillRegistration: "è¾å¥æ³¨åæ°æ®",
        insertLicense: "è¾å¥çæçå¯é¥ä»¥è¿è¡ç¦»çº¿æ¿æ´»",
        invalidEmail: "Email input is invalid",
        invalidPhone: "Phone input is invalid",
        itemsMarkedasterisk: "(items marked with an asterisk must be filled in)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "Leased license",
        licenseActivated: "License already activated",
        licenseStatus: "è®¸å¯è¯ç¶æ",
        licenseWillExpire: "Your license expires in %{dayCount} days",
        licenseWillExpireOneDay: "Your license expires in %{dayCount} day",
        machineInformation: "è®¾å¤ä¿¡æ¯",
        noLicenseAvailable: "no license available",
        noProductsForKey: "There are no products available for the stated identification keys.",
        pointOfSale: "éå®ç¹",
        producer: "çäº§åå®¶",
        reactivate: "Reactivate",
        reactivateLicense: "Reactivate license",
        region: "å°åº",
        registerLicense: "å¤å¶æ¿æ´»è¯·æ±å¹¶è½¬å°",
        registrationForm: "ç»è®°è¡¨",
        selectProduct: "éæ©äº§å",
        serialNumber: "åºåå·",
        skipNewLicense: "If you want to activate new license later you can click on Skip",
        unlimitedLicense: "Unlimited license",
        userId: "ç¨æ·å",
        uuid: "è®¸å¯è¯åç§°",
        versionDetails: "Version Details",
        versionScope: "Version scope",
        versionType: "Version type",
        zip: "é®ç¼"
    },
    login: {
        authenticate: "Authenticate",
        logIn: "ç»å½",
        loginAs: "Log in as another user",
        messages: {
            incorrectUsername: "ç¨æ·åæå¯ç éè¯¯"
        },
        password: "å¯ç ",
        username: "ç¨æ·å"
    },
    machineActionHistory: {
        actionHistory: "æä½åå²è®°å½"
    },
    machineErrors: {
        channel: "é¢é",
        code: "ç ",
        machineErrors: "æºå¨éè¯¯",
        noMachineErrors: "There are currently no machine errors",
        resetErrors: "éç½®éè¯¯"
    },
    machineSettings: {
        action: "Action",
        addAutotask: "Add Autotask",
        autoCanisterIn: "èªå¨è¾å¥ç½",
        autoCanisterOut: "èªå¨è¾åºç½",
        automaticRefill: "Automatic refill",
        autotaskSettings: "Autotask settings",
        backupConfiguration: "Backup dispenser configuration",
        brushMaintenance: "Brush maintenance",
        capMaintenance: "Cap maintenance",
        checkCanisterBeforeDispense: "è°éåæ£æ¥ç½è£",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Check the minimal tintable amount of colorants",
        checkOverfill: "Check can overfill",
        checkTotalCntAmounts: "Check total colorants amount for base paint",
        cleanAll: "Clean all",
        computerReboot: "Computer reboot",
        computerShutdown: "Computer shutdown",
        connectMachine: "è¿æ¥æºå¨",
        days: "Days",
        daysOfMonth: "Days of month",
        devices: "è®¾å¤",
        disabled: "Disabled",
        dispenseAndPurge: "Dispense and purge",
        dispenseOnly: "Dispense only",
        dispenserCleaning: "Dispenser cleaning",
        dispensingWithErrorsEnabled: "Allow dispensing despite the validation errors",
        editAutotask: "Edit Autotask",
        firstRun: "First run",
        hours: "Hours",
        humidifier: "Humidifier",
        humidifierWaterLevelMaintenance: "Humidifier water level maintenance",
        machineConfigurationNoCanisters: "The machine configuration contains no canisters.",
        machineName: "æºå¨åç§°",
        machineSettings: "æºå¨è®¾ç½®",
        manualPuncher: "Manual puncher",
        minDispensedAmount: "Min dispensed amount",
        minutes: "Minutes",
        nextRun: "Next run",
        noAutotasksSet: "No autotasks set",
        noDataAvailable: "No data available",
        noMachine: "æºå¨æªè¿æ¥",
        onStart: "On start",
        plugger: "æä»¶",
        postpone: "Can postpone",
        puncher: "æå­",
        purgeAll: "Purge all",
        purgeOnly: "Purge only",
        recirculateAll: "Recirculate all",
        recirculateChannels: "Recirculate channels",
        recirculationSpeed: "Recirculation speed",
        recirculationTime: "Recirculation time",
        refillAll: "Refill all",
        refillCanisters: "Refill canisters",
        runAt: "Daily at",
        runDefinedDaysAt: "Defined days at",
        runEvery: "Run every",
        runInDays: "Run in days",
        serialNum: "åºåå·",
        settingsMachine: "æºå¨è®¾ç½®",
        smartPurgeAll: "Smart purge all",
        smartPurgeChannels: "Smart purge channels",
        smartPurgeRules: "Smart purge rules",
        startType: "Start type",
        stirAll: "Stir all",
        stirCanisters: "Stir canisters",
        stirringSpeed: "Stirring speed",
        stirringTime: "Stirring time",
        switchPlateMaintenance: "Switch plate maintenance",
        theCurrentlySelectedMachine: "å½åæéæ©çæºå¨",
        threshold: "Threshold",
        turntable: "Turntable",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Volume",
        weekdays: "Weekdays"
    },
    mainTab: {
        acceptedFormula: "Accepted formula",
        addBuildingSite: "Add building site",
        addToFavorites: "æ·»å å°å¸¸ç¨",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "One or more colorants are invalid",
        dispensedPackages: "Dispensed packages",
        dispensingInProgress: "æ­£å¨è°è²",
        dispensingIsAborted: "Dispensing is aborted",
        dispensingIsNotAvailable: "è°è²ä¸å¯è¡",
        dispensingProgress: "%{done} of %{all}",
        editColorant: "ç¼è¾è²æµ",
        editNote: "Edit note",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "Force dispensing",
        formulaInvalidColorants: "éæ¹åå«æ æçè²æµ: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Hidden fandecks",
        hiddenProducts: "Hidden products",
        historicalFormulas: "Historical formulas",
        lowerDeltaNumber: "Lower delta number more accurate match",
        machineError: "Machine error",
        machineIsBusy: "Machine is busy",
        machineNotConnected: "æºå¨æªè¿æ¥",
        manualColorantAddition: "Manual colorant addition",
        modifiedFormula: "Formula is modified",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "New color after scaling",
        newRgbNotAccuratelyMeasured: "New RGB is not accurately measured, it is only indicative",
        noBaseAvailable: "No base is available",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "æ è²æµ",
        noCustomer: "æ ç¨æ·",
        noCustomers: "æ å¯ç¨ç¨æ·",
        noDispenseNotesAvailable: "No notes for dispensing are available",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "æ²¡æéæ©éæ¹",
        noInternalNotesAvailable: "No internal notes are available",
        noNotesAvailable: "No notes are available",
        noPackageAvailable: "No package is available",
        noPackageSelected: "No package is selected",
        noProductAvailable: "No product is available",
        noResultsFound: "No results found",
        openLocalFile: "Open from local database",
        openOnlineFile: "Open from the Internet",
        order: "è®¢å",
        orderingIsNotAvailable: "è®¢åä¸éç¨",
        originalColor: "Original color",
        overAvailableLevel: "Over available level",
        package: "åè£",
        packageIsRequired: "Package is required",
        packaging: "Packaging",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "æå°ä¸å¯è¡",
        productFiles: "Product files",
        productFilesViewer: "Product files viewer",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "å¸¸ç¨ä»·æ ¼",
        resetFormulaData: "New formula",
        rgbOnlyIndicative: "RGB only indicative!",
        saveAsCustom: "ä¿å­å¨",
        saveToStatsIsNotAvailable: "Saving to history is not available",
        searchForCheaper: "Search for cheaper",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "ç¹æ®ä»·æ ¼",
        specialPriceVip: "ç¹æ®ä¸äº«ä»·æ ¼",
        splitFormula: "Split formula",
        withVAT: "å«ç¨",
        withoutVAT: "æªå«ç¨"
    },
    marginSettings: {
        allBases: "All bases",
        allProducts: "ææäº§å",
        editMargin: "ç¼è¾ç©ºä½",
        marginAndDiscountWarning: "You have to set price calculation option for using margins and discounts.",
        marginSettings: "ç©ºä½è®¾ç½®",
        marginsFor: "ç©ºä½æ¥èª",
        markupColorants: "Markup colorant",
        sizeOfPackage: "åè£è§æ ¼",
        valueBase: "Value base",
        valueColorant: "Value colorant"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "Change colorant unit",
        payAttention: "Pay attention!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "è¿æ»¤é¢è²èå´",
            formulasOverLimit: "About %{count} results. Please try typing more characters.",
            foundFormulas: "%{count} formulas found",
            help: "å¸®å©",
            helpText:
                "Type e.g. '%{filter}' to search formulas starting with '%{formula}', product starting with '%{product}' and fandeck '%{fandeck}'.",
            productFilter: "äº§åè¿æ»¤",
            searchInFormulas: "æç´¢éæ¹",
            typeMore: "å¢å æ´å¤å­ç¬¦"
        },
        menu: {
            actionHistory: "åå²",
            additionalFormulaTab: "Additional Formula Tab",
            advancedSettings: "Advanced Settings",
            autotaskSettings: "Autotask Settings",
            availableDatabases: "Available Databases",
            availablePrices: "Available Prices",
            bugReport: "Bug Report",
            canisterBarcodes: "Canister Barcodes",
            canisterDispensingLogic: "Dispensing Logic",
            canisterFilling: "çè£ç½",
            canisterSettings: "Canister Settings",
            clientServerSettings: "å®¢æ·/æå¡å¨è¿æ¥",
            closing: "Closing",
            color: "Color",
            colorModification: "Color Modification",
            colorPanel: "Color Palette Settings",
            colorRepresentation: "Color Representation & Data",
            colorSearch: "Color Search",
            colorant: "Colorant",
            colorantConsumption: "Colorant Consumption",
            colorantPricing: "Colorant Pricing",
            colorantRefillHistory: "Colorant Refill History",
            competitiveSearch: "Competitive Color Search",
            connections: "é¾æ¥",
            currency: "è´§å¸è®¾å®",
            customData: "Custom Data",
            database: "Database",
            databaseCheck: "Database Check",
            databaseConnection: "é¾æ¥æ°æ®åº",
            defaultValues: "Default Values",
            devices: "Devices",
            dispensingHistory: "Dispensing History",
            dispensingSettings: "Dispensing Settings",
            driverSettings: "é©±å¨ç¨å¼è®¾å®",
            environment: "ç¯å¢",
            environmentConfiguration: "ç¯å¢è®¾ç½®",
            environmentalSettings: "Environmental Settings",
            favorites: "å¸¸ç¨",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatting",
            formula: "Formula",
            formulaData: "Data",
            formulaModification: "Formula modification",
            formulaPanels: "Formula Panels",
            formulaSettings: "è®¾ç½®éæ¹",
            formulaUnit: "Formula unit",
            generalSearch: "General Search",
            globalSettingsSearch: "Global Settings Search",
            helpItems: "Help Settings",
            importAndExport: "Import and export",
            importAndExportData: "Data Import & Export",
            importCustomData: "Import Custom Data",
            initialFormulaTab: "Initial Formula Tab",
            interfaceSettings: "Interface Settings",
            keyboardShortcuts: "Keyboard Shortcuts",
            language: "è¯­è¨è®¾ç½®",
            languageSettings: "Language Settings",
            layout: "Layout",
            license: "è®¸å¯è¯",
            licenseData: "License Data",
            licenseIdentification: "License Identification",
            licenseStatus: "è®¸å¯è¯ç¶æ",
            licenseSupplier: "License Supplier",
            licenseVersion: "License Version",
            localData: "Local Data",
            machine: "è®¡ç®æºä¿¡æ¯",
            machineActions: "è®¡ç®æºæä½",
            machineAndDevices: "Machine & Devices",
            machineManagement: "Machine Management",
            machineSettings: "è®¾ç½®è®¡ç®æº",
            mainSettings: "Main Settings",
            maintenance: "ç»´ä¿®ä¿å»",
            marginAndDiscount: "Margin and discount",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "å¯¼èªé¡¹ç®",
            newFormulaWindow: "éæ¹",
            orderSearch: "Order Search",
            orderSettings: "Ordering Settings",
            packageSurcharge: "Package Surcharge",
            popUps: "Pop-Ups",
            posInfo: "POSä¿¡æ¯",
            price: "ä»·æ ¼è®¾å®",
            priceManagement: "ä»·æ ¼ç®¡ç",
            priceSettings: "ä»·æ ¼è®¾å®",
            pricingOptions: "Pricing Options",
            printSettings: "Print Settings",
            productPricing: "Product Pricing",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "æå¨è°é",
            rccConfig: "RCCè®¾ç½®",
            rccConnection: "RCCè¿æ¥ä¸­",
            rccSettings: "RCCè®¾ç½®",
            refillSettings: "Refill Settings",
            refillingLogic: "Refilling Logic",
            registration: "ç»è®°",
            searchSettings: "Search Settings",
            serverPlugins: "Server Plugins",
            serviceActions: "ç»´æ¤æä½",
            settings: "Settings",
            simplifiers: "Simplifiers",
            singleActions: "Single Actions",
            smartPurgeRules: "Smart Purge Rules",
            softwareOptions: "Software Options",
            spectroSettings: "åè°±è®¾ç½®",
            statistics: "ç»è®¡",
            switchToFrontdesk: "Switch to Frontdesk",
            switchToFullRedlike: "Switch to %{name}",
            switchToLight: "Switch to %{name}",
            switchToMachine: "Switch to Machine",
            tabs: "Tabs & Pop-Ups",
            testBarcodes: "Barcode Testing",
            updateOptions: "Update Options",
            userManagemenet: "User Management",
            visibleUnits: "Visible units"
        },
        navBar: {
            barcode: "æ¡ç ",
            help: "å¸®å©",
            hideItems: "Hide products / fandecks"
        },
        notificationPanel: {
            noNotifications: "No new notifications"
        },
        tabBar: {
            closeActive: "å³é­æ´»å¨ä¼è¯",
            closeAll: "å¨é¨å³é­",
            closeAllExceptActive: "é¤æ´»å¨ä¼è¯å¤å¨é¨å³é­",
            customFormula: "Custom Formula",
            dispensingHistory: "Dispensing History",
            favorites: "å¸¸ç¨",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Assign",
        assignment: "Assignment",
        createdDate: "Creation date",
        finishDispensing: "Finish dispensing",
        foundInOrders: "Found in orders",
        inactiveDatabase: "Formula is from inactive or unknown database %{0}",
        inactiveUnknownDatabase: "Formula is from inactive or unknown database",
        newOrderReceived: "You have received a new order!",
        noOrderSelected: "No order selected",
        release: "Release",
        status: {
            accepted: "accepted",
            canceled: "canceled",
            created: "created",
            done: "done",
            partlyDone: "partly done",
            preparing: "preparing",
            unknown: "unknown"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "å°å",
        contactName: "èç³»äººåç§°",
        contactPerson: "èç³»äºº",
        identification: "Identification",
        machineInformation: "Machine Information",
        pos: "ååº",
        secondAddress: "å¤ç¨å°å",
        shopIdentification: "Shop identification",
        shopName: "åºå",
        url: "ç½å",
        zipCode: "é®ç¼"
    },
    priceTypeList: {
        priceBasePurchase: "Cost price for base",
        priceBaseSell: "Sell price for base",
        priceBaseSellFull: "Sell full price for base",
        priceCntPurchase: "Cost price for colorants",
        priceCntPurchaseByColorantName: "Cost price for %{0} colorant",
        priceCntPurchaseByName: "Cost price for colorants by name",
        priceCntSell: "Sell price for colorants",
        priceCntSellByColorantName: "Sell price for %{0} colorant",
        priceCntSellByName: "Sell price for colorants by name",
        priceCntSellFull: "Sell full price for colorants",
        priceCntSellFullByColorantName: "Sell full price for %{0} colorant",
        priceCntSellFullByName: "Sell full price for colorants by name",
        priceGroupBarcode: "Price group barcode",
        priceMarginAll: "Margin for all packages",
        priceMarginPerPkg: "Margin for one package",
        priceSellPriceAll: "Sell price for all packages",
        priceSellPricePerKg: "Sell price per kilogram",
        priceSellPricePerL: "Sell price per liter",
        priceSellPricePerPkg: "Sell price for one package",
        priceSurchargeAll: "Surcharge for all packages",
        priceSurchargePerPkg: "Surcharge for one package",
        priceTintPurchaseAll: "Tint cost price for all packages",
        priceTintPurchasePerPkg: "Tint cost price for one package",
        priceTintSellFullAll: "Tint sell full price for all packages",
        priceTintSellFullAllPerPackage: "Tint sell full price for one package",
        priceTotalPurchaseAll: "Total cost price for all packages",
        priceTotalPurchasePerKg: "Total cost price per kilogram",
        priceTotalPurchasePerL: "Total cost price per liter",
        priceTotalPurchasePerPkg: "Total cost price for one package",
        priceTotalSellFullAll: "Total sell full price for all packages",
        priceTotalSellFullPerKg: "Total sell full price per kilogram",
        priceTotalSellFullPerLiter: "Total sell full price per liter",
        priceTotalSellFullPerPackage: "Total sell full price per package"
    },
    pricing: {
        allBases: "All bases",
        allPackages: "All packages",
        backup: "Backup",
        basesOfProduct: "Bases of %{productName}",
        colorantPricing: "Colorant Pricing",
        export: "Export",
        import: "Import",
        packagePricing: "Package Pricing",
        packageSurcharge: "Package surcharge",
        packages: "Packages",
        packagesOfProduct: "Packages of %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Price group price per liter",
        priceGroups: "Price groups",
        pricePerLiter: "Price per liter",
        productPricing: "Product Pricing",
        purchasePrice: "Purchase price",
        purchasePricePerLiter: "Purchase price per liter",
        sellPrice: "Sell price",
        surcharge: "Surcharge"
    },
    print: {
        adminRightsRequired: "Admin rights are required to edit or create a new template.",
        allowAutomaticPrint: "Allow automatic print",
        allowPrintAfterDispensing: "Allow print after dispensing",
        allowPrintBeforeDispensing: "Allow print before dispensing",
        automaticPrint: "Print automatically",
        choosePrinter: "éæ©æå°æº",
        chooseSettings: "ç¼è¾è®¾ç½®",
        chooseTemplate: "éæ©æ¨¡æ¿",
        copies: "Copies",
        createTemplate: "Create template",
        createTemplateHint: "Create a new template from scratch. Save it to the templates folder and restart RCC.",
        defaultPrinter: "Printer",
        defaultSettings: "Default settings",
        defaultTemplate: "é»è®¤æ¨¡æ¿",
        editTemplate: "Edit template",
        editTemplateHint: "Edit %{name}. Changes will be visible after RCC restart.",
        noEditTemplate: "No template to edit",
        noPrinterSelected: "No printer is selected",
        noPrintersAvailable: "No printers available",
        noTemplateSelected: "No template is selected",
        noTemplatesAvailable: "æ æææ¨¡æ¿",
        numberOfCopies: "ä»½æ°",
        openTemplateEditor: "Open template editor",
        printAfterDispensing: "Print after dispensing",
        printAsImage: "Print as image",
        printBeforeDispensing: "Print before dispensing",
        printOnRequest: "Print on request",
        printOptions: "Print Options",
        printPagesAfterDispensing: "Number of copies after can dispensing",
        printPagesBeforeDispensing: "Number of copies before can dispensing",
        printPreview: "Print Preview",
        printSettings: "Print Settings",
        printTaskLinkVariable: "Link to a variable",
        printVariable: "Print variable",
        printerName: "æå°æºåç§°",
        printerOptions: "æå°æºéé¡¹",
        printerSettings: "æå°æºéé¡¹",
        quickTintTemplate: "Quick Tint template",
        setDefaultPrinter: "Set default printer",
        setDefaultTemplate: "Set default template",
        setQuickTintTemplate: "Set Quick Tint template",
        showPreviewDialogBeforePrint: "Show preview dialog before print",
        template: "æ¨¡æ¿",
        templateName: "æ¨¡æ¿åç§°",
        templateSettings: "Template Settings"
    },
    printTemplate: {
        baseCode: "Base code",
        baseName: "Base name",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "Customer city",
        customerEmail: "Customer email",
        customerName: "Customer name",
        customerPhone: "Customer phone",
        customerStreet: "Customer street",
        customerZipCode: "Customer ZIP code",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BFS grade",
        orderQrCode: "QR code",
        packageOrderCount: "Package order count",
        posAddress: "POS address",
        posAddressSecond: "POS address 2",
        posCity: "POS city",
        posContact: "POS contact",
        posEmail: "POS email",
        posPhone: "POS phone",
        posUrl: "POS Url",
        posZipCode: "POS ZIP code",
        priceBasePurchaseWithTax: "Cost price for base with VAT",
        priceBaseSellWithTax: "Sell price for base with VAT",
        priceCntPurchaseWithTax: "Cost price for colorants with VAT",
        priceCntTotalSellWithTax: "Sell price for colorants with VAT",
        priceMarginAllWithTax: "Margin for all packages with VAT",
        priceMarginPerPkgWithTax: "Margin for one package with VAT",
        priceSellPriceAllWithTax: "Sell price for all packages with VAT",
        priceSellPricePerKgWithTax: "Sell price per kilogram with VAT",
        priceSellPricePerLWithTax: "Sell price per liter with VAT",
        priceSellPricePerPkgWithTax: "Sell price for one package with VAT",
        priceSurchargeAllWithTax: "Surcharge for all packages with VAT",
        priceSurchargePerPkgWithTax: "Surcharge for one package with VAT",
        priceTintPurchaseAllWithTax: "Tint cost price for all packages with VAT",
        priceTintPurchasePerPkgWithTax: "Tint cost price for one package with VAT",
        priceTotalPurchaseAllWithTax: "Total cost price for all packages with VAT",
        priceTotalPurchasePerKgWithTax: "Total cost price per kilogram with VAT",
        priceTotalPurchasePerLWithTax: "Total cost price per liter with VAT",
        priceTotalPurchasePerPkgWithTax: "Total cost price for one package with VAT",
        productAltName: "Product",
        recipeInline: "Recipe"
    },
    products: {
        bases: "Bases",
        numberOfProducts: "Number of products",
        packagesFor: "Packages for",
        sizeOfPackage: "Size of package"
    },
    purgeModal: {
        purgeAll: "å¨é¨å²æ´",
        purgeAllChannels: "Purge all channels",
        purgeVolume: "å²æ´æ°é",
        startPurge: "å¼å§å²æ´"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "æ­£å¨å²æ´",
        dispensingIsNotAvailable: "å²æ´ä¸å¯è¡",
        machineNotConnected: "æºå¨æªè¿æ¥",
        noColorantsSelected: "æ²¡æéæ©è²æµ",
        noPrinterAvailable: "Print cannot be carried out as there is no printer available.",
        noTemplateAvailable: "Print cannot be carried out as there is no template available.",
        overMaxCanisterSize: "ä¸ç§æå¤ç§è²æµçéè¶è¿å¶æå¤§å¼"
    },
    quickTintSettings: {
        alphabetically: "Alphabetically",
        byCanister: "By canister",
        closeAfterDispensing: "Close after dispensing",
        closeBeforeDispensing: "Close before dispensing",
        quickTintSettings: "Quick Tint Settings",
        sorting: "Sorting",
        windowClosingRules: "Window closing rules"
    },
    rccButtons: {
        abort: "ä¸­æ­¢",
        all: "å¨é¨",
        cancel: "åæ¶",
        continue: "ç»§ç»­",
        help: "å¸®å©",
        ignore: "å¿½ç¥",
        no: "ä¸",
        noToAll: "å¹¶éææ",
        ok: "å¥½",
        postpone: "postpone",
        resume: "resume",
        retry: "éè¯",
        skip: "è·³è¿",
        yes: "æ¯",
        yesToAll: "å¨é¨é½æ¯"
    },
    rccDialog: {
        98: "ç¨æ¡å½¢ç æ£æ¥åºç¡%{0}ã",
        99: "æ¾ç½®åºç¡%{0}å¹¶ç¡®è®¤ï¼åå»âç¡®å®âï¼",
        100: "è°è²æºç»åºéè¯¯ä¿¡æ¯ã éç½®éè¯¯æ¶æ¯ï¼",
        101: "è°è²æºç»åºéè¯¯ä¿¡æ¯ã æ æ³ç»§ç»­ã",
        102: "éç½®å¤±è´¥ã æ æ³ç»§ç»­ã",
        103: "éæ¹åå«æ æçè²æµï¼ %{0}",
        104: "éæ¹åå«æ æçè²æµï¼ %{0}",
        105: "è²æµï¼ %{0}ä½äºè­¦åçº§å«",
        106: "è²æµï¼ %{0}ä½äºè­¦åçº§å«",
        107: "è²æµï¼ %{0}ä½äºä¸´çå¼",
        108: "è²æµï¼ %{0}ä½äºä¸´çå¼",
        109: "å®æ¾ç½",
        110: "å®æ¾åºç¡æ¶æç½ï¼ %{0}ç¨äºéæ¹ï¼%{1}",
        111: "ç§»é¤ç½å­",
        112: "ç»ç½å­æå­åï¼",
        113: "éç½®éè¯¯æ¶æ¯ï¼è¯·ç­åã",
        114: "ç§»å¨çç½å°ï¼è¯·ç¨åã",
        115: "ç½å­æå­ï¼è¯·ç­å",
        116: "Dispensing formula %{0}, please wait|Package: %{1} of %{2}|Product: %{3}|Base: %{4}|Can size: %{5}",
        117: "Dispensing formula %{0}, please wait|Package: %{1} of %{2}|Product: %{3}|Base: %{4}|Can size: %{5}",
        118: "è°éï¼è¯·ç­å|åè£ï¼ %{0} of %{1}",
        119: "è°éï¼è¯·ç­å|åè£ï¼ %{0} of %{1}",
        120: "åæ¶è°éï¼è¯·ç­å",
        121: "æ«æè²æµæ¡ç ",
        122: "æ«æåºæ¬æ²¹æ¼ç½æ¡å½¢ç |äº§åï¼ %{0} |åºæ¬æ²¹æ¼ï¼ %{1} |ç½è£è§æ ¼ï¼%{2}",
        123: "è°éè¿ç¨ä¸­æ­ã æ¨è¦ç»§ç»­åï¼",
        124: "è°è²æºéè¯¯ä¿¡æ¯ %{0}ï¼ %{1} æ¯å¦è¦ç»§ç»­è°éè¿ç¨ï¼",
        125: "ç¡®ä¿æ¿èµ°åç¨è¿çç½å­",
        126: "ä½¿ç¨æ°ç½ï¼å ä¸ºè°éè¿ç¨åæ¬¡å¼å§",
        127: "è²æµï¼ %{0}ä½äºæå°åé å°½ç®¡åºç°æ­¤è­¦åï¼æ¨æ¯å¦è¦ç»§ç»­è¯¥è¿ç¨ï¼",
        128: "è²æµï¼ %{0}ä½äºæå°åé å°½ç®¡åºç°æ­¤è­¦åï¼æ¨æ¯å¦è¦ç»§ç»­è¯¥è¿ç¨ï¼",
        129: "æéçéæ¹ä¸ç¬¦åä¸»å¯¼è§åï¼è²æµæ»éï¼ %{0} %{1}ï¼æå¤§åè®¸è²æµæ°éï¼%{2}%{3}ã å°½ç®¡åºç°æ­¤è­¦åï¼æ¨æ¯å¦è¦ç»§ç»­è¯¥è¿ç¨ï¼",
        130: "è°è²æºç»åºéè¯¯ä¿¡æ¯ã éç½®éè¯¯æ¶æ¯ï¼",
        131: "è°è²æºç»åºéè¯¯ä¿¡æ¯ã æ æ³ç»§ç»­ã",
        132: "éç½®å¤±è´¥ã æ æ³ç»§ç»­ã",
        133: "å²æ´éæ¹ä¸ºç©ºï¼æ æ³ç»§ç»­",
        134: "å²æ´éæ¹ä¸­åå«æ æ³è°éçé¡¹ç®ã æ¨è¦ç»§ç»­åï¼",
        135: "å®æ¾ç½å­ä¸ºäºå²æ´",
        136: "ç§»é¤ç½å­ä¸ºäºå²æ´",
        137: "éç½®éè¯¯æ¶æ¯ï¼è¯·ç­åã",
        138: "ææ¾å°ç§»å¨ï¼è¯·ç¨åã",
        139: "å²æ´ï¼è¯·ç¨åã",
        140: "å²æ´ï¼è¯·ç¨åã",
        141: "åæ¶å²æ´ï¼è¯·ç­å¾ã",
        142: "Can for purge is missing, check that the can is properly placed",
        143: "Purge formula contains items that cannot be purged, do you want to continue?",
        144: "Place can for purge",
        145: "Preparing, please wait",
        146: "Finishing, please wait",
        150: "æ¸æ´ï¼è¯·ç¨åã",
        151: "æ¸æ´ï¼è¯·ç¨åã",
        152: "åæ¶æ¸æ´ï¼è¯·ç­å¾ã",
        160: "åå¾ªç¯ï¼è¯·ç­åã",
        161: "åå¾ªç¯ï¼è¯·ç­åã",
        162: "åæ¶åå¾ªç¯ï¼è¯·ç­å¾ã",
        170: "ææä¸­ï¼è¯·ç­åã",
        171: "ææä¸­ï¼è¯·ç­åã",
        172: "åæ¶ææï¼è¯·ç­åã",
        180: "ä¸è°è²æºå»ºç«è¿æ¥ï¼è¯·ç­åã",
        181: "%{0}ï¼%{1}æ æ³è¿æ¥å°è°è²æº",
        182: "æ æ³è¿æ¥å°è°è²æº è¯·åéæ¥å¿æä»¶ä»¥è·åæ´å¤ä¿¡æ¯",
        183: "Dispenser is missing colorant: %{0} that is defined in your database",
        184: "Dispenser is missing colorants: %{0} that are defined in your database",
        185: "å³é­ä¸è°è²æºçè¿æ¥ï¼è¯·ç­åã",
        190: "å³é­æå¡çªå£ä»¥ç»§ç»­",
        200: "éç½®ï¼è¯·ç­å",
        201: "ç¡¬éç½®ï¼è¯·ç¨åã",
        202: "åå§åï¼è¯·ç­åã",
        203: "éç½®éè¯¯æ¶æ¯ï¼è¯·ç­åã",
        205: "æå¼èªå¨å°å£ï¼è¯·ç­åã",
        206: "å³é­èªå¨å°å£ï¼è¯·ç­åã",
        207: "èªå¨å°å£è¿è¡ä¸­ï¼è¯·ç­åã",
        210: "æå­ï¼è¯·ç­å¾ã",
        211: "æ­£å¨æå¥ï¼è¯·ç­å¾ã",
        215: "ç½çæçåä¸ç§»å¨ï¼è¯·ç­åã",
        216: "ç½çæçåä¸ç§»å¨ï¼è¯·ç­åã",
        217: "çç½ç®¡çæçæ­£å¨ç§»å¨ï¼è¯·ç­åã",
        220: "å°è½¬çç§»è³åæ¬¡å¡«è£çä½ç½®ï¼%{0}ï¼è¯·ç­åã",
        221: "å°è½¬çç§»è³åºç¡çä½ç½®ï¼%{0}ï¼è¯·ç­åã",
        222: "è½¬çç§»å¨ä¸­ï¼è¯·ç­åã",
        230: "è°è²æºæ­£å¿ï¼è¯·ç­åã",
        240: "éæ°å¡«åå®¹å¨%{0}",
        241: "Please refill canister %{0}",
        242: "Positioning canister: %{0} (%{1}) to refill position",
        243: "Please refill canister %{0} using barcode",
        244: "Please refill canister %{0} using barcode",
        250: "Remove brush container, clean it and fill it with water according to the instructions",
        251: "Put back brush container",
        254: "Opening autocap",
        255: "Clean autocap according to the instructions",
        256: "Confirm when cleaning has finished and autocap is back in place",
        257: "Closing autocap",
        260: "Remove switch plate and clean it",
        261: "Put back switch plate",
        265: "Clean the machine with a cloth and remove all spilled colorant or other liquid",
        266: "Confirm when done",
        270: "Refill the humidifier water container and confirm when done",
        271: "Refill the humidifier water container and confirm when done",
        272: "Water level is still low, check it again",
        273: "Water level is still low, check it again",
        274: "Check the water level in humidifier container and refill if needed",
        275: "Please wait",
        280: "Rebooting computer",
        281: "Shutting down computer",
        300: "Base can missing, check that the can is placed properly",
        301: "Preparing, please wait",
        302: "Finishing, please wait",
        303: "Formula cannot be tinted as it contains colorant: %{0} which is over max dispense amount defined for canister",
        304: "Formula cannot be tinted as it contains colorants: %{0} which are over max dispense amounts defined for canisters",
        305: "Colorant: %{0} cannot be dispensed at once, do you want to split the formula?",
        306: "Colorants: %{0} cannot be dispensed at once, do you want to split the formula?",
        307: "Colorant: %{0} won't be dispensed by dispenser, do you want to continue and add it manually?",
        308: "Colorants: %{0} won't be dispensed by dispenser, do you want to continue and add them manually?",
        309: "Selected formula is empty, use base can as it is",
        310: "No colorant will be dispensed, prepare base can for manual colorant addition",
        311: "Remove base can and prepare it for manual colorant addition",
        312: "Add manually %{0} %{1} of colorant: %{2}, confirm when done",
        313: "Dispense manually formula",
        314: "Selected formula breaks the overfill rule, total amount of colorants: %{0} %{1}, maximum allowed amounts of colorants: %{2} %{3}. Do you want to continue despite this warning?",
        315: "Scan or type UFI code of base can",
        316: "Scan or type UFI code of base can|Product: %{0}|Base: %{1}|Can size: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Automatic purge task will be started",
        401: "Automatic purge task will be started",
        405: "Brush container needs be maintained",
        406: "Brush container needs be maintained",
        410: "Automatic cap maintenance will be started",
        411: "Automatic cap maintenance will be started",
        415: "Switch plate has to be cleaned",
        416: "Switch plate has to be cleaned",
        420: "Dispenser has to be cleaned",
        421: "Dispenser has to be cleaned",
        425: "Refill of canisters will be started",
        426: "Refill of canisters will be started",
        430: "Computer reboot has been scheduled",
        431: "Computer reboot has been scheduled",
        435: "Computer shutdown has been scheduled",
        436: "Computer shutdown has been scheduled",
        440: "Dispenser cleaning has been scheduled",
        441: "Dispenser cleaning has been scheduled",
        445: "Dispenser recirculation has been scheduled",
        446: "Dispenser recirculation has been scheduled",
        450: "Dispenser stirring has been scheduled",
        451: "Dispenser stirring has been scheduled",
        990: "è°è²æºéè¯¯%{0}ï¼%{1} æ¯å¦è¦éè¯ï¼",
        991: "åé¨éè¯¯æ¶æ¯ï¼%{0}",
        200000001: "å®æ¾ç½å­",
        200000002: "ç§»é¤ç½å­",
        200000003: "%{0}çæ°éâç»§ç»­ä½äºæå°åéï¼åæèªè´ï¼â",
        200000004: "è¡¥å%{0}ââ"
    },
    rccDriverSettings: {
        databasePath: "Database path",
        dispenser: "Dispenser",
        dispenserConfigurationFile: "Dispenser config file",
        driverPath: "é©±å¨è·¯å¾",
        extensionPath: "å»¶ç³è·¯å¾",
        folder: "Folder",
        formulaPath: "éæ¹è·¯å¾",
        host: "Host",
        iddPath: "IDDéç½®æä»¶",
        italtintoPath: "ItalTintoéç½®æä»¶",
        lldPath: "LLD path",
        machineType: "æºå¨ç±»å",
        noMachineAvailable: "No machine is available",
        protocolVersion: "åè®®çæ¬",
        rccDriverSettings: "é©±å¨ç¨å¼è®¾å®",
        resultPath: "Result path",
        save: "ä¿å­è®¾ç½®",
        saveSettingsWarning: "è­¦åï¼ æ´æ¹æ­¤é¨åå¯è½ä¼å¯¼è´è°è²æºåçæé",
        serviceSwPath: "Service Software path",
        simulationPath: "æ¨¡æè·¯å¾"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Allow manual colorant addition",
        ask: "Ask",
        canHandlingOptions: "å¤è§è¯å«éé¡¹",
        checkCanBeforeDispense: "è°è²åæ£æ¥ç½å­",
        checkOverfill: "æ£æ¥æ¯å¦åæ»¡",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Colorant package validation only",
        disable: "Disable",
        dispenseInvalidColorants: "Dispense invalid colorants",
        dispensingOptions: "è°ééé¡¹",
        enable: "Enable",
        enableUserIdentification: "User identification",
        fullValidation: "Full validation",
        machineAccuracyWarning: "Machine accuracy warning",
        machineOptions: "Machine options",
        machineUnit: "Machine unit",
        minimalDispenseAmount: "æå°åé",
        placeCanSensor: "ç½è£æåºå¨",
        placeCanSensorDelay: "ç½è£æåºå¨å»¶è¿",
        rccMachineSettings: "æºå¨è®¾ç½®",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "ç§»é¤ç½è£ä¼ æå¨",
        removeCanSensorDelay: "ç§»é¤ç½è£ä¼ æå¨å»¶è¿",
        save: "ä¿å­è®¾ç½®",
        sec: "ç§",
        skipPlaceCanDialog: "Skip place can dialog",
        skipRemoveCanDialog: "Skip remove can dialog",
        splitFormula: "Split formula",
        tmcEnabled: "å¼å¯TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "æ«æåºç¡æµæ¡å½¢ç ",
        validateBarcodeRefill: "Refill barcode validation",
        validateColorantsDuringInit: "Validate colorants during initialization"
    },
    rccPanel: {
        actionsRunningOnDispenser: "æææºæ­£å¨æ§è¡ä»»å¡",
        addLevel: "æ·»å ç­çº§",
        addManually: "Add manually",
        barcodeNotSet: "Canister %{colorantName} (%{canisterName}) has no barcode assigned.",
        cancel: "åæ¶",
        dispenseFormula: "Dispense formula",
        dispenserIdle: "æºå¨å¤äºå¾æºç¶æ",
        dispenserIsBusy: "æºå¨æ­£å¿",
        dispenserIsIdle: "æºå¨å¤äºå¾æºç¶æ",
        dispenserIsReady: "æºå¨å·²ç»åå¤å¥½",
        dispensingFormula: "éæ¹è°å¶",
        errorCode: "Error code",
        explanation: "Explanation",
        fillToMax: "å¡«åè³æå¤§éåº¦",
        finished: "Finished",
        inProgress: "In progress",
        machineIsReady: "æºå¨åå¤å¥½äº",
        moveToFill: "Move to fill",
        noMachineDialog: "æ æºå¨é¾æ¥",
        of: "æ",
        packageSize: "åè£è§æ ¼",
        placeBaseCan: "Place base can",
        pleaseCheckYourMachineConnection: "Please check your machine connection.",
        pleaseRefill: "è¯·éæ°æ·»å ",
        solution: "Solution",
        subErrors: "Sub errors",
        timeToEnd: "å©ä½æ¶é´ï¼",
        tintingFormula: "åééæ¹",
        tintingPleaseWait: "æºå¨æ­£å¨è°éï¼è¯·ç­åã",
        validateBaseCan: "Validate base can",
        waiting: "Waiting"
    },
    rccSettigns: {
        rccSettigns: "RCCè¿æ¥",
        rccUrl: "URL RCC"
    },
    rccSpectroDialog: {
        100: "éè¿èçè¿æ¥è®¾å¤ã ç¡®ä¿èçå·²æå¼å¹¶ä¸æ¨çè®¾å¤å¯ä»¥å·¥ä½ã",
        101: "éè¿èçè¿æ¥è®¾å¤ã ç¡®ä¿èçå·²æå¼å¹¶ä¸æ¨çè®¾å¤å¯ä»¥å·¥ä½ã",
        110: "ç¡®ä¿å·²è¿æ¥Nanoï¼ç¶åæè®¾å¤å¯å¨æé®å¯å¨",
        111: "æªæ£æµå°Nanoã æ¨æ³åè¯ä¸æ¬¡åï¼",
        112: "æ­å¼Nanoçè¿æ¥ï¼ç­å¾10ç§éï¼ç¶åéæ°è¿æ¥å¹¶ç»§ç»­",
        120: "Connecting to your device, please wait",
        121: "Instrument hasn't been detected. Do you want to retry?",
        200: "å°è®¾å¤æ¾å¨é»è²ç·ç ä¸ç¶åç»§ç»­ææè®¾å¤ä¸çæé®",
        201: "å°è®¾å¤æ¾å¨é»è²ç·ç ä¸ç¶åç»§ç»­",
        202: "å°è®¾å¤æ¾å¨é»è²ç·ç ä¸ç¶åæè®¾å¤ä¸çæé®",
        205: "å°è®¾å¤æ¾å¨ç½è²ç·ç ä¸ç¶åç»§ç»­ææè®¾å¤ä¸çæé®",
        206: "å°è®¾å¤æ¾å¨ç½è²ç·ç ä¸ç¶åç»§ç»­",
        207: "å°è®¾å¤æ¾å¨ç½è²ç·ç ä¸ç¶åæè®¾å¤ä¸çæé®",
        210: "å°è®¾å¤æ¾å¨è¯æ­ç£è´´ä¸ç¶åç»§ç»­ææè®¾å¤ä¸çæé®",
        211: "å°è®¾å¤æ¾å¨è¯æ­ç£è´´ä¸ç¶åç»§ç»­",
        212: "å°è®¾å¤æ¾å¨è¯æ­ç£è´´ä¸ç¶åæè®¾å¤ä¸çæé®",
        215: "åä¸è®¾å¤çç¶åç»§ç»­ææè®¾å¤ä¸çæé®",
        216: "åä¸è®¾å¤çç¶åç»§ç»­",
        217: "åä¸è®¾å¤çå¹¶æè®¾å¤ä¸çæé®",
        220: "å°è®¾å¤æ¾å¨é¶ä½å¾åä¸ç¶åç»§ç»­ææè®¾å¤ä¸çæé®",
        221: "å°è®¾å¤æ¾å¨é¶ä½å¾åä¸ç¶åç»§ç»­",
        222: "å°è®¾å¤æ¾å¨é¶ä½å¾åä¸ç¶åæè®¾å¤ä¸çæé®",
        224: "Place the instrument on calibration pad and continue or press instrument button",
        225: "Place the instrument on calibration pad and continue",
        226: "Place the instrument on calibration pad and press instrument button",
        227: "Place the instrument on calibration pad and press instrument button",
        295: "å¨é©±å¨ç¨åºçªå£ä¸­å®ææ ¡å",
        296: "Instrument is not connected, do you want to open connection to it?",
        297: "åå¤è¿è¡æ ¡åæ­¥éª¤ï¼è¯·ç­åã",
        298: "æ ¡åï¼è¯·ç­å",
        299: "å®ææ ¡åæ­¥éª¤ï¼è¯·ç­åã",
        300: "å°è®¾å¤è®¾ç½®ä¸ºè²æ ·ç¶åç»§ç»­ææè®¾å¤ä¸çæé®",
        301: "å°è®¾å¤è®¾ç½®ä¸ºè²æ ·ç¶åç»§ç»­",
        302: "å°è®¾å¤è®¾ç½®ä¸ºè²æ ·ç¶åæè®¾å¤ä¸çæé®",
        303: "Instrument is not calibrated, do you want to proceed with calibration?",
        304: "Instrument is not connected, do you want to open connection to it?",
        390: "Select measure mode",
        395: "å¨é©±å¨ç¨åºçªå£ä¸­å®ææµé",
        397: "åå¤æµéï¼è¯·ç­åã",
        398: "æ­£å¨æµéï¼è¯·ç­åã",
        399: "æµéç»æï¼è¯·ç­åã",
        498: "æµéè£è½½ï¼è¯·ç­åã",
        499: "å¨é¨æµéè£è½½ï¼è¯·ç­åã",
        900: "è®¾å¤éè¯¯%{0}ï¼%{1} æ¯å¦è¦éè¯ï¼",
        901: "åé¨éè¯¯æ¶æ¯ï¼%{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "The computer has to have Bluetooth connection. The spectro has to be paired with the computer. Windows 10 with 2018 automn update required.",
        DatacolorSilent:
            "When using Silent mode, Datacolor windows are shown directly in %{name}. In these windows, spectro parameters cannot be changed.",
        DatacolorUseDiagnosticTile: "Using diagnostic tile improves the measurement quality.",
        comPort: "éè®¯ç«¯å£",
        diagnosticTile: "ä½¿ç¨æ°æ®é¢è²è¯æ­å¾å",
        measureModes: "Measure modes",
        measureModesOrder: "Measure modes order",
        model: "åå·",
        noSpectroAvailable: "No spectro is available",
        rccSpectroSettings: "åè°±è®¾ç½®",
        save: "ä¿å­è®¾ç½®",
        silent: "æ°æ®é¢è²å¨å¾æº",
        simulationPath: "æ¨¡æè·¯å¾",
        spectroType: "åè°±ç±»å",
        useProfiledValues: "ä½¿ç¨éç½®å¼"
    },
    recirculateChannels: {
        recirculateAllChannels: "æææ¸ éå¾ªç¯",
        recirculateChannels: "å¾ªç¯æ¸ é",
        recirculatingSpeed: "å¾ªç¯éåº¦",
        recirculatingTime: "å¾ªç¯æ¶é´",
        startRecirculating: "å¼å§å¾ªç¯"
    },
    redlikeLight: {
        finishPreviousSteps: "Please finish previous steps",
        searchBySpectro: "Search by spectro",
        searchFormula: "Search formula",
        selectBase: "Select base",
        selectColor: "Select color",
        selectCustomer: "Select customer",
        selectFandeck: "Select fandeck",
        selectPackage: "Select package",
        selectProduct: "Select product",
        startSelectFandeck: "Start by selecting fandeck",
        startSelectProduct: "Start by selecting product",
        stepByStepProgress: "You can progress step by step",
        typeHereToSearch: "Type here to search",
        typeToFilter: "Type to filter"
    },
    restartModal: {
        computerNeedsRestart: "Computer needs restart!",
        notCompletelyTranslated:
            "Language change requires software restart. Some parts of the software may not be translated completely at this time.",
        restartIsRequired: "Software restart is required after the changes have been made.",
        softwareNeedsRestart: "%{name} Needs Restart!"
    },
    searchPanel: {
        basePlaceholder: "or type a base name",
        baseStartPlaceholder: "Start by typing a base name",
        colorCodeNamePlaceholder: "or type a formula code/name",
        colorCodeNameStartPlaceholder: "Start by typing a formula code/name",
        colorCodePlaceholder: "æè¾å¥éæ¹ç¼ç ",
        colorCodeStartPlaceholder: "å¼å§è¾å¥äº§åç¼ç e",
        colorNameCodePlaceholder: "or type a formula name/code",
        colorNameCodeStartPlaceholder: "Start by typing a formula name/code",
        colorNamePlaceholder: "æè¾å¥éæ¹åç§°",
        colorNameStartPlaceholder: "å¼å§è¾å¥äº§ååç§°",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "æè¾å¥é¢è²èå´çåç§°",
        fandeckStartPlaceholder: "å¼å§è¾å¥äº§åå´çåç§°",
        formulaByColor: "Formula by color",
        noResultsFound: "No results found",
        packagePlaceholder: "or type a package name",
        packageStartPlaceholder: "Start by typing a package name",
        productPlaceholder: "æè¾å¥éæ¹åç§°",
        productStartPlaceholder: "å¼å§è¾å¥äº§ååç§°",
        standard: "æ å",
        typeFandeckToFilter: "Type here to filter by fandeck name",
        typeProductToFilter: "Type here to filter by product name"
    },
    sendOrderModal: {
        customNote: "èªå®ä¹è¯´æ",
        noCompatibleServers: "æ¨çç½ç»ä¸­æ²¡æå¼å®¹çæå¡å¨",
        orderOverview: "é¢è§è®¢å",
        selectTargetMachine: "Select the target machine",
        sendOrder: "åéè®¢å",
        sendOrderTo: "æ¨çè®¢åå°åéå° %{serverName}",
        targetMachine: "ç®æ æºå¨"
    },
    server: {
        computerId: "è®¡ç®æºID",
        ip: "IP",
        selectServer: "éæ©ä¸ä¸ªå¯ç¨æå¡å¨",
        server: "æå¡å¨"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Active server plugins",
        currentlyActive: "The currently active plugins",
        plugin: "Plugin",
        pluginName: "Plugin name",
        statusActive: "Active",
        statusInactive: "Unactive"
    },
    serviceActionsSettings: {
        canisterLevel: "ç½è£æ°´å¹³",
        capClose: "å³é­",
        capMiddle: "ä¸­é´",
        capOpen: "æå¼",
        cleanAllChannels: "æ¸æ´ææéé",
        cleanChannels: "ééæ¸æ°",
        computer: "Computer",
        computerReboot: "Computer reboot",
        computerShutdown: "Computer shutdown",
        connectMachine: "è¿æ¥æºå¨",
        general: "éç¨",
        initialize: "åå§å",
        noMachineIsConnected: "æªææºå¨é¾æ¥",
        plug: "æå¤´",
        plugger: "æä»¶",
        punch: "æå­",
        puncher: "ç½æå­",
        purgeChannels: "å²æ´éé",
        recirculate: "Recirculate",
        recirculateAllChannels: "åå¾ªç¯æææ¸ é",
        recirculateChannels: "åå¾ªç¯éé",
        serviceActions: "æä½ç»´æ¤",
        setCanisterLevel: "è®¾ç½®å®¹å¨çº§å«",
        shelfDown: "æçåä¸",
        shelfUp: "æçåä¸",
        showServiceWindow: "æ¾ç¤ºæå¡çªå£",
        smartPurgeAllChannels: "Smart purge all channels",
        smartPurgeChannels: "Smart purge channels",
        startErrorReset: "ä»éç½®éè¯¯å¼å§",
        startHardReset: "å¼å§ç¡¬éç½®",
        startReset: "å¼å§éç½®",
        stirAllCanisters: "ææææç½å­",
        stirCanisters: "ææç½",
        stirCanistersMore: "ææç½"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Compare the color sample to the gloss scale and select gloss level",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "æ ¡å",
        calibrateInstrument: "Calibrate instrument",
        connectDevice: "è¿æ¥è®¾å¤",
        connectedTo: "è¿æ¥å°ï¼",
        connectingDevice: "è¿æ¥è®¾å¤",
        deselectAll: "Deselect all",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "æ¨çè®¾å¤æªæ ¡å",
        eraseResult: "Erase result",
        filter: "æ»¤é",
        foundInFormulas: "å¨éæ¹ä¸­æ¾å°",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Your instrument needs to be calibrated.",
        manualInput: "Manual input",
        measure: "Measure",
        measurementResult: "æµéç»æ",
        noFilters: "No filters available",
        noFormulas: "æ¾ä¸å°éæ¹",
        noSelectedSpectro: "æªéæ©åè°±",
        notSelected: "æªéæ©",
        pressConnectButton: "æ£æ¥ä¸è®¾å¤çè¿æ¥ï¼ç¶åæ é¾æ¥ ââæé®",
        searchFormulas: "æç´¢éæ¹",
        selectSpectro: "Select spectro",
        showDetails: "Show details",
        skipCalibration: "Skip calibration",
        spectroIsConnected: "åè°±å·²è¿æ¥",
        spectroIsReady: "åè°±ä»ªå·²ç»åå¤å¥½",
        spectroReady: "è®¾å¤å·²åå¤å¥½æ§è¡å¶ä»ä»»å¡",
        startCalibrateNow: "Start calibrate now",
        startMeasureText: "æ¨çè®¾å¤å·²æ ¡åã æ¨å¯ä»¥å¼å§æµéã",
        tolerance: "å¬å·®èå´",
        toleranceOfDevitation: "åå·®å¬å·®"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Custom %{1} %{2}",
        deleteSelectedRecords: "å é¤æéè®°å½",
        exportHistory: "Export history",
        finishFormula: "Finish formula",
        foundInFormulas: "å¨éæ¹ä¸­æ¾å°",
        hideHiddenRecords: "Do not show hidden records",
        hideSelectedRecord: "Hide selected record",
        historicalFormula: "Historical formula",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Restore selected record",
        showAllRecords: "Show all records",
        standardFormula: "Standard formula",
        unknownFormula: "Unknown formula"
    },
    stirCanisters: {
        selectCanisters: "éæ©ç½",
        startStirring: "å¼å§ææ",
        stirAllCanisters: "ææææç½å­",
        stirCanisters: "ææç½",
        stirringSpeed: "ææéåº¦",
        stirringTime: "æææ¶é´"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "No item is assigned to barcode %{code}",
        pleaseScanBarcode: "Please scan the barcode of base, product, package or other items",
        testBarcodes: "Test Barcodes"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "Last",
        next: "Next"
    },
    ufiCodeModal: {
        currentStatus: "Current Status",
        detailedInfoForColorant: "Detailed info for colorant %{colorantName}",
        userSetUfiCode: "User set UFI code, current value"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Base UFI code validation",
        confirmColorantRefilling: "Confirm colorant refilling",
        enableUfiCodes: "Enable UFI codes",
        printUfiCode: "Print if amount of colorant is over",
        printUfiCodePercentage: "Print percentage if amount of colorant is over",
        scanOrTypeUfiCode: "Scan or type UFI code",
        scanOrTypeUfiCodeOfBase: "Scan or type UFI code of base can",
        ufiCodesByPercentage: "Use UFI codes by percentage",
        ufiCodesFromDatabase: "Use UFI codes from the database",
        ufiCodesFromLastFilling: "Use UFI codes from the last filling"
    },
    userSettings: {
        addUser: "Add User",
        assignedUserGroups: "Assigned user groups",
        availableUserGroups: "Available user groups",
        barcode: "Barcode",
        confirmNewPassword: "Confirm password",
        editPassword: "Edit Password",
        editUser: "Edit User",
        enableAutoLogin: "Enable auto login",
        newPassword: "New password",
        noChange: "There is no change to be saved",
        oldPassword: "Old password",
        password: "Password",
        passwordsDoNotMatch: "Passwords do not match",
        restoreUser: "This user has been deleted. Do you want to restore him?",
        userGroup: "User Group",
        userGroups: "User Groups",
        userManagement: "User Management",
        userSettings: "User Settings",
        username: "Username",
        usernameIsMissing: "Username is missing."
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Friday",
        monday: "Monday",
        saturday: "Saturday",
        sunday: "Sunday",
        thursday: "Thursday",
        tuesday: "Tuesday",
        wednesday: "Wednesday"
    },
    welcome: {
        availableDatabase: "æå¡å¨æ æ³è¿æ¥å°æ°æ®åºã æ£æ¥æ¨çæ°æ®åºéç½®ã",
        availableDatabaseLocalError: "è¿æ¥å°æ¬å°æ°æ®åºæ¶åºéï¼æä»¶éè¯¯ï¼å¯ç æ æï¼",
        availableDatabaseLocalMissing: "æ¬å°æ°æ®åºæä»¶ä¸¢å¤±",
        availableDatabaseLocalUpdate: "æ¬å°æ°æ®åºéè¦æ´æ°å°è¾æ°çæ¬",
        availableDatabaseMainAndLocalError: "åæ¶è¿æ¥å°ä¸»æ°æ®åºåæ¬å°æ°æ®åºæ¶åºéï¼æä»¶éè¯¯ï¼å¯ç æ æï¼",
        availableDatabaseMainAndLocalMissing: "ä¸»æ°æ®åºåæ¬å°æ°æ®åºæä»¶ä¸¢å¤±",
        availableDatabaseMainAndLocalUpdate: "ä¸»æ°æ®åºåæ¬å°æ°æ®åºé½éè¦æ´æ°å°è¾æ°çæ¬",
        availableDatabaseMainError: "è¿æ¥å°ä¸»æ°æ®åºæ¶åºéï¼æä»¶éè¯¯ï¼å¯ç æ æï¼",
        availableDatabaseMainMissing: "ä¸»è¦æ°æ®æä»¶ä¸¢å¤±",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "ä¸»è¦æ°æ®åº",
        closing: "%{name}å³é­ä¸­",
        compatibility: "æ£æ¥æå¡å¨ççæ¬ã æ¨çå®¢æ·ç«¯ä»ä¸æå¡å¨%{0}ææ´é«çæ¬å¼å®¹ã",
        compatibilityCheck: "æ­£å¨è¿è¡å¼å®¹æ§æ£æ¥",
        compatibilityDatabase: "æ¨çæ°æ®åºä¸æå¡å¨ä¸å¼å®¹ã æ£æ¥æ¨çæ°æ®åºéç½®ã",
        connectingServer: "æ­£å¨è¿æ¥æå¡å¨%{ip}",
        databaseCompatibility: "Your database is not compatible with the current software",
        databasesCompatibility: "Your databases are not compatible with the current software",
        licenseVerification: "æ­£å¨è¿è¡è®¸å¯è¯æ£æ¥",
        loading: "ä¸è½½",
        lostConnection: "ä¸æå¡å¨çè¿æ¥ä¸¢å¤±",
        moduleMessage: "è¯·æ³¨ææ¨¡åçéæ©ï¼å ä¸ºå°æ¥çæ¨¡åæ´æ¹å°ä»å¯¹ç¹æç¨æ·å¯ç¨ã",
        refresh: "å·æ°",
        restoring: "Restoring connection",
        selectModule: "éæ©ä¸ä¸ªå¯ç¨çæ¨¡å",
        stopUpdate: "Stop update",
        updateDatabase: "åçº§æ°æ®åº",
        updatingDatabase: "æ°æ®åºåçº§ä¸­",
        updatingDatabases: "Databases are updating",
        updatingWarning: "Database structure is being updated to the newest version, please wait.",
        updatingWarningInfo:
            "Do not close this window as it would result in the necessity to do the update from scratch."
    }
};
